(function () {
function initVehicleCustomizer() {
  const root = document.getElementById('vehicle_options');
  if (!root || root.dataset.aoVehicleInitialized === 'true') return;
  root.dataset.aoVehicleInitialized = 'true';

  const configElement = document.getElementById('vehicle_customizer_config');
  let vehicleCustomizerConfig = {};
  try { vehicleCustomizerConfig = JSON.parse(configElement?.textContent || '{}'); } catch (error) { console.error('Vehicle customizer config error:', error); }
  const variants = Array.isArray(vehicleCustomizerConfig.variants) ? vehicleCustomizerConfig.variants : [];
  const optionNames = Array.isArray(vehicleCustomizerConfig.optionNames) ? vehicleCustomizerConfig.optionNames : [];
  const shopifyCountryCode = vehicleCustomizerConfig.countryCode || 'SK';
  const shopifyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // V66: photo → design → size/frame → data flow with requested validation/summary refinements.

  const stepEls = {
    1: document.getElementById('step_upload'),
    2: document.getElementById('step_size'),
    3: document.getElementById('step_format'),
    4: document.getElementById('step_vehicle'),
    5: document.getElementById('step_success')
  };

  let currentStep = 1;
  let attempted = false;
  let filesState = [];
  let summaryThumbHtml = '';
  let lastCompleteState = false;
  let celebrationTimeout = null;
  let uploadPollInterval = null;
  let suppressUploadedFiles = false;
  let uploadEventsActive = false;
  let nativeUploadMode = false;
  const MAX_NATIVE_FILES = 10;
  const MAX_NATIVE_FILE_BYTES = 20 * 1024 * 1024;
  const MIN_PHOTO_SHORT_EDGE = 1200;
  const NATIVE_MIME_ALLOWLIST = new Set(['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif']);
  const boundUploadInputs = new WeakSet();
  let nativeUploadBound = false;

  const sizeProperty = document.getElementById('size_property');
  const frameProperty = document.getElementById('frame_property');

  const summaryPriceEl = document.getElementById('summary_price');
  const summaryOldPriceEl = document.getElementById('summary_old_price');
  const summarySaveEl = document.getElementById('summary_save');

  const knowRadios = root.querySelectorAll('input[name="properties[Údaje o vozidle]"]');
  const dataBlock = document.getElementById('vehicle_data_fields');
  const spzBlock = document.getElementById('vehicle_spz_fields');
  const modeBlock = document.getElementById('vehicle_mode_block');
  const modeLabel = document.getElementById('vehicle_mode_label');
  const modeNotice = document.getElementById('vehicle_mode_notice');
  const detailsStepForCopy = document.getElementById('step_vehicle');
  const step2Title = detailsStepForCopy ? detailsStepForCopy.querySelector('.vehicle-step__title') : null;
  const step2Subtitle = detailsStepForCopy ? detailsStepForCopy.querySelector('.vehicle-step__subtitle') : null;
  const subjectField = document.getElementById('vehicle_subject_field');
  const subjectEl = document.getElementById('vehicle_subject');
  const subjectLabel = document.getElementById('vehicle_subject_label');
  const subjectHelp = document.getElementById('vehicle_subject_help');
  const yearField = document.getElementById('vehicle_year_field');
  const yearLabel = document.getElementById('vehicle_year_label');
  const engineField = document.getElementById('vehicle_engine_field');
  const engineLabel = document.getElementById('vehicle_engine_label');
  const kwField = document.getElementById('vehicle_kw_field');
  const kwLabel = document.getElementById('vehicle_kw_label');
  const kwHelp = document.getElementById('vehicle_kw_help');
  const engineCodeField = document.getElementById('vehicle_engine_code_field');
  const engineCodeEl = document.getElementById('vehicle_engine_code');

  const yearEl = document.getElementById('vehicle_year');
  const engineEl = document.getElementById('vehicle_engine');
  const kwEl = document.getElementById('vehicle_kw');
  const spzEl = document.getElementById('vehicle_spz');
  const spzCountryEl = document.getElementById('vehicle_spz_country');
  const noteEl = document.getElementById('vehicle_note');

  const preview = document.getElementById('vehicle_preview');
  const status = document.getElementById('file_status');
  const uploadliftFilesJsonEl = document.getElementById('uploadlift_files_json');
  const uploadliftFilesUrlsEl = document.getElementById('uploadlift_files_urls');
  const uploadliftMount = document.getElementById('uploadlift_mount');
  const uploadTrigger = document.getElementById('custom_uploadlift_shell');
  const nativeUploadInput = document.getElementById('vehicle_native_upload');
  const uploadFallbackNotice = document.getElementById('vehicle_upload_fallback');
  const cropModal = document.getElementById('vehicle_crop_modal');
  const cropDialog = cropModal ? cropModal.querySelector('.vehicle-crop-dialog') : null;
  const cropImageBox = document.getElementById('vehicle_crop_imagebox');
  const cropImage = document.getElementById('vehicle_crop_image');
  const cropSelection = document.getElementById('vehicle_crop_selection');
  const cropCancel = document.getElementById('vehicle_crop_cancel');
  const cropApply = document.getElementById('vehicle_crop_apply');
  let cropState = null;
  let cropPointerId = null;
  let cropAction = null;
  let cropStartPoint = null;
  let cropStartRect = null;
  let cropScrollY = 0;
  const step3Title = document.getElementById('step3_title');
  const step3Subtitle = document.getElementById('step3_subtitle');
  const uploadCardTitle = document.getElementById('upload_card_title');
  const uploadCardText = document.getElementById('upload_card_text');
  const uploadCardMeta = document.getElementById('upload_card_meta');
  const uploadCardWait = document.getElementById('upload_card_wait');
  const uploadLogoNotice = document.getElementById('upload_logo_notice');
  const backgroundField = document.getElementById('vehicle_background_field');
  const livePhotoEmpty = document.getElementById('vehicle_live_photo_empty');
  const liveDesignEmpty = document.getElementById('vehicle_live_design_empty');
  const liveBgNote = document.getElementById('vehicle_live_bg_note');

  const errFrame = document.getElementById('err_frame');
  const errSize = document.getElementById('err_size');
  const errDesign = document.getElementById('err_design');
  const errSubject = document.getElementById('err_subject');
  const errYear = document.getElementById('err_year');
  const errEngine = document.getElementById('err_engine');
  const errKw = document.getElementById('err_kw');
  const errEngineCode = document.getElementById('err_engine_code');
  const errSpz = document.getElementById('err_spz');
  const errPhotos = document.getElementById('err_photos');
  const errBackground = document.getElementById('err_background');
  const errCart = document.getElementById('err_cart');

  const sumFrame = document.getElementById('sum_frame');
  const sumSize = document.getElementById('sum_size');
  const sumDesign = document.getElementById('sum_design');
  const sumDesignPreviewRow = document.getElementById('sum_design_preview_row');
  const sumDesignPreview = document.getElementById('sum_design_preview');
  const sumDesignPreviewImage = document.getElementById('sum_design_preview_image');
  const sumDesignPreviewNumber = document.getElementById('sum_design_preview_number');
  const sumMode = document.getElementById('sum_mode');
  const sumYear = document.getElementById('sum_year');
  const sumEngine = document.getElementById('sum_engine');
  const sumKw = document.getElementById('sum_kw');
  const sumSubject = document.getElementById('sum_subject');
  const sumEngineCode = document.getElementById('sum_engine_code');
  const sumSpz = document.getElementById('sum_spz');
  const sumNote = document.getElementById('sum_note');
  const sumBg = document.getElementById('sum_bg');
  const sumBgRow = document.getElementById('sum_bg_row');
  const sumPhotoCount = document.getElementById('sum_photo_count');
  const sumPhotoNames = document.getElementById('sum_photo_names');
  const sumPhotoEmpty = document.getElementById('sum_photo_empty');
  const sumPhotoPreviewImage = document.getElementById('sum_photo_preview_image');
  const sumThumbs = document.getElementById('sum_thumbs');

  const sumModeRow = document.getElementById('sum_mode_row');
  const sumYearRow = document.getElementById('sum_year_row');
  const sumEngineRow = document.getElementById('sum_engine_row');
  const sumKwRow = document.getElementById('sum_kw_row');
  const sumSubjectRow = document.getElementById('sum_subject_row');
  const sumEngineCodeRow = document.getElementById('sum_engine_code_row');
  const sumSpzRow = document.getElementById('sum_spz_row');
  const sumNoteRow = document.getElementById('sum_note_row');
  const sumEngineKey = document.getElementById('sum_engine_key');
  const sumKwKey = document.getElementById('sum_kw_key');
  const sumSubjectKey = document.getElementById('sum_subject_key');

  const step1Number = document.getElementById('step1_number');
  const step2Number = document.getElementById('step2_number');
  const step3Number = document.getElementById('step3_number');
  const step4Number = document.getElementById('step4_number');

  const progressWrap = document.getElementById('vehicle_progress');
  const progressFill = document.getElementById('vehicle_progress_fill');
  const progressPercent = document.getElementById('vehicle_progress_percent');
  const progressState = document.getElementById('vehicle_progress_state');
  const progressBottom = document.getElementById('vehicle_progress_bottom');

  const progressStickyWrap = document.getElementById('vehicle_progress_sticky');
  const progressStickyFill = document.getElementById('vehicle_progress_sticky_fill');
  const progressStickyPercent = document.getElementById('vehicle_progress_sticky_percent');
  const progressStickyState = document.getElementById('vehicle_progress_sticky_state');
  const progressStickyBottom = document.getElementById('vehicle_progress_sticky_bottom');
  const stickyBackButton = document.getElementById('vehicle_sticky_back');

  const btnToStep2 = document.getElementById('to_step_2');
  const btnToStep3 = document.getElementById('to_step_3');
  const btnToStep4 = document.getElementById('to_step_4');

  const btnBack1 = document.getElementById('back_to_1');
  const btnBack2 = document.getElementById('back_to_2');
  const btnBack3 = document.getElementById('back_to_3');

  const btnAddToCart = document.getElementById('add_to_cart_custom');
  const rightsConfirm = document.getElementById('vehicle_rights_confirm');
  const publishAll = document.getElementById('vehicle_publish_all');
  const successText = document.getElementById('vehicle_success_text');
  const btnCreateNew = document.getElementById('create_new_customizer');
  const btnCheckout = document.getElementById('go_checkout');
  const specialDesignModal = document.getElementById('special_design_modal');
  const openSpecialDesignModalButton = document.getElementById('open_special_design_modal');
  const technicalDetails = document.getElementById('vehicle_technical_details');
  const liveMockup = document.getElementById('vehicle_live_mockup');
  const liveDesign = document.getElementById('vehicle_live_design');
  const livePhoto = document.getElementById('vehicle_live_photo');
  const liveTitle = document.getElementById('vehicle_live_title');
  const liveHint = document.getElementById('vehicle_live_hint');
  const purchaseBar = document.getElementById('vehicle_purchase_bar');
  const purchasePrice = document.getElementById('vehicle_purchase_price');
  const purchaseMissing = document.getElementById('vehicle_purchase_missing');
  const purchaseBreakdown = document.getElementById('vehicle_purchase_breakdown');
  const purchaseAdd = document.getElementById('vehicle_purchase_add');
  const draftResume = document.getElementById('vehicle_draft_resume');
  const draftContinue = document.getElementById('vehicle_draft_continue');
  const draftDiscard = document.getElementById('vehicle_draft_discard');
  const DRAFT_KEY = 'ao:vehicle-draft:v66';
  const DRAFT_MAX_AGE = 24 * 60 * 60 * 1000;
  let draftSaveTimer = null;
  let restoringDraft = false;
  try { localStorage.removeItem('ao:vehicle-draft:v65'); } catch (_) {}

  function normalizeText(v) {
    return (v || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();
  }


  function track(eventName, detail) {
    if (window.AOAnalytics && typeof window.AOAnalytics.track === 'function') {
      window.AOAnalytics.track(eventName, detail || {});
    }
  }

  const sizeIndex = optionNames.findIndex(function (n) {
    const s = normalizeText(n);
    return s.includes('velk') || s.includes('variant') || s.includes('size') || s.includes('rozm');
  });

  const frameIndex = optionNames.findIndex(function (n) {
    const s = normalizeText(n);
    return s.includes('ram') || s.includes('frame');
  });

  function fmt(v) {
    return Number(v).toFixed(2).replace('.', ',') + ' €';
  }


  function nonEmpty(v) {
    return ((v || '').trim().length >= 1);
  }


  function getVisitorCountryCode() {
    const localized = (shopifyCountryCode || '').toString().toUpperCase();
    if (localized) return localized;

    const lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (lang === 'sk' || lang.startsWith('sk-')) return 'SK';
    if (lang === 'cs' || lang === 'cz' || lang.startsWith('cs-') || lang.startsWith('cz-')) return 'CZ';
    if (lang === 'hu' || lang.startsWith('hu-')) return 'HU';
    if (lang === 'pl' || lang.startsWith('pl-')) return 'PL';
    return 'SK';
  }

  function getCountryLabel(code) {
    if (code === 'SK') return '🇸🇰 Slovensko';
    if (code === 'CZ') return '🇨🇿 Česko';
    if (code === 'HU') return '🇭🇺 Maďarsko';
    if (code === 'PL') return '🇵🇱 Poľsko';
    return 'Do tejto krajiny zatiaľ nedoručujeme.';
  }

  function updateShippingStatusBar() {
    if (window.AODelivery) window.AODelivery.refresh(root);
  }


  function frameKeyFromValue(v) {
    const s = normalizeText(v);
    if (s.includes('bez')) return 'withoutFrame';
    if (s.includes('s ramom') || s.includes('s rámom')) return 'withFrame';
    return '';
  }

  function sizeKeyFromValue(v) {
    const s = normalizeText(v);
    if (s.includes('a4')) return 'A4';
    if (s.includes('a3')) return 'A3';
    if (s.includes('50') && s.includes('70')) return '50x70';
    return '';
  }

  function baseSizeFromValue(v) {
    const key = sizeKeyFromValue(v);
    if (key === 'A4') return '21 × 30 cm';
    if (key === 'A3') return '30 × 40 cm';
    if (key === '50x70') return '50 × 70 cm';
    return '';
  }

  function frameLabelFromValue(v) {
    const key = frameKeyFromValue(v);
    if (key === 'withoutFrame') return 'Bez rámu';
    if (key === 'withFrame') return 'S rámom';
    return '';
  }

  function currentPickedValue() {
    const checked = root.querySelector('input[type="radio"][name="custom_size"]:checked');
    return checked ? checked.value : '';
  }

  function currentFrameValue() {
    const checked = root.querySelector('input[type="radio"][name="custom_frame"]:checked');
    return checked ? checked.value : '';
  }

  function getSelectedDesign() {
    const checked = root.querySelector('input[name="properties[Dizajn]"]:checked');
    return checked ? checked.value : '';
  }

  function getPriceData(frameValue = currentFrameValue(), sizeValue = currentPickedValue()) {
    const variant = findVariantBySelection(frameValue, sizeValue);
    if (!variant) return null;
    const now = Number(variant.price || 0) / 100;
    const old = Number(variant.compare_at_price || 0) / 100;
    return {
      now: now,
      old: old > now ? old : null,
      available: variant.available !== false,
      variant: variant
    };
  }

  function safeText(v) {
    return (v || '').trim() || '-';
  }

  function getSelectedVehicleMode() {
    const checked = root.querySelector('input[name="properties[Údaje o vozidle]"]:checked');
    return checked ? checked.value : 'Neviem údaje';
  }

  function getDesignMode() {
    const design = getSelectedDesign();
    if (design === 'Dizajn 2') return 'title_only';
    if (design === 'Dizajn 5') return 'engine';
    if (design.indexOf('Dizajn 7') === 0) return 'user_design';
    return 'car';
  }

  function isCarDesignMode() {
    return getDesignMode() === 'car';
  }

  function getStep2ModeLabel() {
    const mode = getDesignMode();
    if (mode === 'title_only') return 'Len typ a model auta';
    if (mode === 'engine') return 'Údaje o motore';
    if (mode === 'user_design') return 'Tvoja hotová grafika';
    return getSelectedVehicleMode();
  }

  function getSelectedBackgroundMode() {
    const checked = root.querySelector('input[name="properties[Úprava pozadia]"]:checked');
    return checked ? checked.value : '';
  }

  function getEffectiveBackgroundMode() {
    const mode = getDesignMode();
    return mode === 'engine' || mode === 'user_design' ? '' : getSelectedBackgroundMode();
  }

  function isKnowMode() {
    return getSelectedVehicleMode() === 'Viem údaje';
  }

  function findVariantBySelection(frameValue, sizeValue) {
    const wantedFrame = frameKeyFromValue(frameValue);
    const wantedSize = sizeKeyFromValue(sizeValue);

    if (!wantedFrame || !wantedSize) return null;

    return variants.find(function (v) {
      const opts = v.options || [];
      let frameMatches = false;
      let sizeMatches = false;

      if (frameIndex > -1) {
        frameMatches = frameKeyFromValue(opts[frameIndex]) === wantedFrame;
      } else {
        frameMatches = opts.some(function (opt) { return frameKeyFromValue(opt) === wantedFrame; });
      }

      if (sizeIndex > -1) {
        sizeMatches = sizeKeyFromValue(opts[sizeIndex]) === wantedSize;
      } else {
        sizeMatches = opts.some(function (opt) { return sizeKeyFromValue(opt) === wantedSize; });
      }

      return frameMatches && sizeMatches;
    }) || null;
  }

  function getSelectedVariant() {
    return findVariantBySelection(currentFrameValue(), currentPickedValue());
  }

  /* V236: obraz ide do košíka za plnú cenu svojho variantu. Režim zálohy je
     odstránený — vyžadoval ručný doplatok pri každej objednávke a Shopify
     nevedel započítať celú cenu obrazu do prahu dopravy zdarma. */
  function cartVariantId(variant) {
    return variant ? variant.id : 0;
  }

  function getUploadInput() {
    const selectors = [
      '#step_upload input[name="properties[upload]"]:not(#vehicle_native_upload)',
      '#step_upload .filepond--root input[type="file"]:not(#vehicle_native_upload)',
      '#step_upload .cl-upload-wrapper input[type="file"]:not(#vehicle_native_upload)',
      '#step_upload .upload-container input[type="file"]:not(#vehicle_native_upload)',
      'input[name="properties[upload]"]:not(#vehicle_native_upload)',
      '.filepond--root input[type="file"]:not(#vehicle_native_upload)',
      '.cl-upload-wrapper input[type="file"]:not(#vehicle_native_upload)',
      '.upload-container input[type="file"]:not(#vehicle_native_upload)'
    ];

    for (let i = 0; i < selectors.length; i++) {
      const el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function setNativeFallbackActive(active) {
    nativeUploadMode = !!active;
    if (uploadFallbackNotice) uploadFallbackNotice.hidden = !nativeUploadMode;
    if (uploadTrigger) uploadTrigger.classList.toggle('is-native-fallback', nativeUploadMode);
    if (nativeUploadMode && uploadCardWait) {
      uploadCardWait.textContent = '';
      uploadCardWait.hidden = true;
    }
  }

  function triggerRealUploader(event) {
    if (!uploadTrigger) return;

    const target = event && event.target;
    if (target && target.closest && target.closest('input[type="file"]')) return;

    // V53: always prefer the browser's native picker. It is reliable in Safari
    // and does not depend on an app DOM node being mounted at the right moment.
    if (nativeUploadInput) {
      setNativeFallbackActive(true);
      nativeUploadInput.click();
      return;
    }

    const input = getUploadInput();
    if (input) input.click();
  }

  if (uploadTrigger) {
    uploadTrigger.addEventListener('click', triggerRealUploader);
    uploadTrigger.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      triggerRealUploader(event);
    });
  }

  function getUploadRoot(input) {
    if (!input) return null;
    return input.closest('.filepond--root') ||
      input.closest('.cl-upload-wrapper') ||
      input.closest('.upload-container') ||
      input.parentElement;
  }

  function configureUploadForMultipleFiles(input) {
    if (!input) return;

    input.multiple = true;
    input.setAttribute('multiple', 'multiple');

    if (window.FilePond && typeof window.FilePond.find === 'function') {
      try {
        const pond = window.FilePond.find(input);
        if (pond && typeof pond.setOptions === 'function') {
          pond.setOptions({
            allowMultiple: true,
            allowReplace: false,
            maxFiles: 10
          });
        }
      } catch (error) {
        console.warn('Upload-Lift multiple files setup failed:', error);
      }
    }
  }

  function prepareRealUploader() {
    const input = getUploadInput();
    configureUploadForMultipleFiles(input);
    const uploaderRoot = getUploadRoot(input);
    if (uploaderRoot && !uploadliftMount.contains(uploaderRoot)) {
      uploaderRoot.classList.add('vehicle-upload-source');
    }
    return { input: input, root: uploaderRoot };
  }

  function getUploadValueInput() {
    const selectors = [
      'input[name="properties[upload]"]',
      'input[type="hidden"][name="properties[upload]"]',
      'input[type="text"][name="properties[upload]"]'
    ];

    for (let i = 0; i < selectors.length; i++) {
      const el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function getUploadUrls() {
    const input = getUploadValueInput();
    if (!input) return [];

    const raw = (input.value || '').trim();
    if (!raw) return [];

    return raw.split(',').map(function (v) {
      return v.trim();
    }).filter(Boolean).slice(0, 10);
  }

  function serializableFilesState() {
    return filesState.map(function (file) {
      return {
        id: file.id || '',
        name: file.name || '',
        url: file.source === 'native' ? '' : (file.url || ''),
        source: file.source || 'upload-lift'
      };
    });
  }

  function syncUploadHiddenFields() {
    const serialized = serializableFilesState();
    const serverUrls = serialized.map(function (file) { return file.url; }).filter(Boolean);
    if (uploadliftFilesJsonEl) {
      uploadliftFilesJsonEl.value = serialized.length ? JSON.stringify(serialized) : '';
    }
    if (uploadliftFilesUrlsEl) {
      uploadliftFilesUrlsEl.value = serverUrls.join(', ');
    }
  }

  function setPreviewLoading(isLoading) {
    if (!preview) return;
    preview.classList.toggle('is-loading', !!isLoading);
    if (isLoading) {
      preview.innerHTML = '';
    }
  }

  function updateStatus() {
    if (!status) return;

    if (preview && preview.classList.contains('is-loading')) {
      status.textContent = 'Nahrávanie môže trvať približne 10 sekúnd. Stránku neobnovuj — fotografia sa pridá automaticky.';
      return;
    }

    if (filesState.length === 0) {
      status.textContent = getDesignMode() === 'engine' ? 'Fotografia motora je voliteľná – môžeš pokračovať bez nej' : 'Zatiaľ nebola vybraná žiadna fotografia';
    } else if (filesState.length === 1) {
      status.textContent = 'Vybraná fotografia: 1';
    } else {
      status.textContent = 'Vybrané fotografie: ' + filesState.length;
    }
  }

  function stopUploadPolling() {
    if (uploadPollInterval) {
      clearInterval(uploadPollInterval);
      uploadPollInterval = null;
    }
  }

  async function removeRealUploadFromApp(targetFile, targetIndex) {
    const input = getUploadInput();
    const removeAll = !targetFile;
    let removed = false;

    if (input && window.FilePond && typeof window.FilePond.find === 'function') {
      try {
        const pond = window.FilePond.find(input);
        if (pond && typeof pond.getFiles === 'function' && typeof pond.removeFile === 'function') {
          const pondFiles = pond.getFiles();

          if (removeAll) {
            await Promise.all(pondFiles.map(function (file) {
              return Promise.resolve(pond.removeFile(file.id)).catch(function () {});
            }));
            removed = pondFiles.length > 0;
          } else {
            const targetId = String(targetFile.id || '');
            const targetUrl = String(targetFile.url || '');
            let pondFile = pondFiles.find(function (file) {
              const possibleValues = [file.id, file.serverId, file.source];
              return possibleValues.some(function (value) {
                const normalized = String(value || '');
                return normalized && (normalized === targetId || normalized === targetUrl);
              });
            });

            if (!pondFile && Number.isInteger(targetIndex)) {
              pondFile = pondFiles[targetIndex];
            }

            if (pondFile) {
              await Promise.resolve(pond.removeFile(pondFile.id)).catch(function () {});
              removed = true;
            }
          }
        }
      } catch (error) {
        console.warn('Upload-Lift FilePond remove failed:', error);
      }
    }

    const selectors = [
      '.filepond--action-remove-item',
      '.filepond--action-revert-item-processing',
      '.filepond--action-abort-item-processing',
      'button[aria-label*="Remove"]',
      'button[aria-label*="Delete"]',
      'button[title*="Remove"]',
      'button[title*="Delete"]'
    ];

    if (!removed && !removeAll && uploadliftMount && Number.isInteger(targetIndex)) {
      const pondItems = uploadliftMount.querySelectorAll('.filepond--item');
      const pondItem = pondItems[targetIndex];
      if (pondItem) {
        for (let i = 0; i < selectors.length; i++) {
          const button = pondItem.querySelector(selectors[i]);
          if (button) {
            button.click();
            removed = true;
            break;
          }
        }
      }
    }

    if (removeAll) {
      for (let i = 0; i < selectors.length; i++) {
        const buttons = uploadliftMount ? uploadliftMount.querySelectorAll(selectors[i]) : [];
        buttons.forEach(function (btn) { btn.click(); });
        if (buttons.length) removed = true;
      }

      document.querySelectorAll(
        'input[name="properties[upload]"], ' +
        'input[name="properties[Upload]"], ' +
        'input[name="properties[Upload súbory JSON]"], ' +
        'input[name="properties[Uploadnuté fotky]"]'
      ).forEach(function (valueInput) {
        valueInput.value = '';
        valueInput.dispatchEvent(new Event('input', { bubbles: true }));
        valueInput.dispatchEvent(new Event('change', { bubbles: true }));
      });

      if (input) {
        try { input.value = ''; } catch (e) {}
      }
    }

    return removed;
  }

  function renderPreviews() {
    if (!preview) return;

    preview.classList.remove('is-loading');
    preview.innerHTML = '';

    if (!filesState.length) {
      updateStatus();
      updateLiveMockup();
      return;
    }

    filesState.forEach(function (file, fileIndex) {
      const item = document.createElement('div');
      item.className = 'vehicle-file-item';

      if (file.url) {
        const thumbWrap = document.createElement('span');
        thumbWrap.className = 'vehicle-file-item__thumb';
        const image = document.createElement('img');
        image.src = file.url;
        image.alt = 'Náhľad ' + (file.name || ('fotografie ' + (fileIndex + 1)));
        image.loading = 'lazy';
        thumbWrap.appendChild(image);
        item.appendChild(thumbWrap);
      } else {
        const icon = document.createElement('span');
        icon.className = 'vehicle-file-item__icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '✓';
        item.appendChild(icon);
      }

      const copy = document.createElement('span');
      copy.className = 'vehicle-file-item__copy';
      const name = document.createElement('strong');
      name.textContent = file.name || ('Fotografia ' + (fileIndex + 1));
      const meta = document.createElement('small');
      meta.textContent = file.source === 'native' ? 'Fotografia pripravená' : 'Súbor pripravený';
      copy.appendChild(name);
      copy.appendChild(meta);

      const actions = document.createElement('span');
      actions.className = 'vehicle-file-item__actions';

      if (file.source === 'native' && file.file) {
        const cropBtn = document.createElement('button');
        cropBtn.type = 'button';
        cropBtn.className = 'vehicle-file-item__crop';
        cropBtn.textContent = 'Orezať';
        cropBtn.setAttribute('aria-label', 'Orezať súbor ' + (file.name || (fileIndex + 1)));
        cropBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openVehicleCrop(fileIndex);
        });
        actions.appendChild(cropBtn);
      }

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'vehicle-file-item__remove';
      removeBtn.textContent = 'Odstrániť';
      removeBtn.setAttribute('aria-label', 'Odstrániť súbor ' + (file.name || (fileIndex + 1)));

      removeBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (file.source === 'native') {
          if (file.url && file.url.indexOf('blob:') === 0) URL.revokeObjectURL(file.url);
        } else {
          await removeRealUploadFromApp(file, fileIndex);
        }

        filesState = filesState.filter(function (entry, index) {
          if (file.id) return entry.id !== file.id;
          if (file.url) return entry.url !== file.url;
          return index !== fileIndex;
        });
        syncUploadHiddenFields();
        setPreviewLoading(false);
        renderPreviews();
        updateSummary(false);
        updateStepState();
        clearError(null, errPhotos);
        track('vehicle_photo_removed', { remaining: filesState.length });
      });
      actions.appendChild(removeBtn);

      item.appendChild(copy);
      item.appendChild(actions);
      preview.appendChild(item);
    });

    updateStatus();
    updateLiveMockup();
    scheduleVehicleDraftSave();
  }

  function clampCrop(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function renderVehicleCropRect() {
    if (!cropState || !cropSelection) return;
    const rect = cropState.rect;
    cropSelection.style.left = rect.left + '%';
    cropSelection.style.top = rect.top + '%';
    cropSelection.style.width = (rect.right - rect.left) + '%';
    cropSelection.style.height = (rect.bottom - rect.top) + '%';
  }

  function setVehicleCropRect(nextRect) {
    if (!cropState) return;
    const min = 8;
    const rect = {
      left: clampCrop(Number(nextRect.left), 0, 100 - min),
      top: clampCrop(Number(nextRect.top), 0, 100 - min),
      right: clampCrop(Number(nextRect.right), min, 100),
      bottom: clampCrop(Number(nextRect.bottom), min, 100)
    };
    if (rect.right - rect.left < min) rect.right = Math.min(100, rect.left + min);
    if (rect.bottom - rect.top < min) rect.bottom = Math.min(100, rect.top + min);
    cropState.rect = rect;
    renderVehicleCropRect();
  }

  function vehicleCropPoint(event) {
    const bounds = cropImageBox.getBoundingClientRect();
    return {
      x: clampCrop((event.clientX - bounds.left) / Math.max(1, bounds.width) * 100, 0, 100),
      y: clampCrop((event.clientY - bounds.top) / Math.max(1, bounds.height) * 100, 0, 100)
    };
  }

  function lockVehicleCropScroll() {
    cropScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('vehicle-crop-open');
    document.body.classList.add('vehicle-crop-open');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + cropScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockVehicleCropScroll() {
    document.documentElement.classList.remove('vehicle-crop-open');
    document.body.classList.remove('vehicle-crop-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, cropScrollY);
  }

  function closeVehicleCrop() {
    if (!cropState) return;
    const previousFocus = cropState.previousFocus;
    const sourceUrl = cropState.sourceUrl;
    cropState = null;
    if (cropModal) cropModal.hidden = true;
    if (cropImage) cropImage.removeAttribute('src');
    if (sourceUrl) {
      try { URL.revokeObjectURL(sourceUrl); } catch (error) {}
    }
    unlockVehicleCropScroll();
    if (previousFocus instanceof HTMLElement) {
      try { previousFocus.focus({ preventScroll: true }); } catch (error) {}
    }
  }

  function openVehicleCrop(fileIndex) {
    const entry = filesState[fileIndex];
    if (!entry || !entry.file || !cropModal || !cropImage || !cropSelection || !cropImageBox) return;
    const sourceFile = entry.originalFile || entry.file;
    const objectUrl = URL.createObjectURL(sourceFile);
    const probe = new Image();
    const previousFocus = document.activeElement;
    probe.onload = function () {
      if (Math.min(probe.naturalWidth, probe.naturalHeight) < MIN_PHOTO_SHORT_EDGE) {
        showError(null, errPhotos, `Fotografia má iba ${probe.naturalWidth} × ${probe.naturalHeight} px. Pre kvalitnú tlač odporúčame aspoň ${MIN_PHOTO_SHORT_EDGE} px na kratšej strane.`);
      }
      cropState = {
        index: fileIndex,
        image: probe,
        sourceFile: sourceFile,
        sourceUrl: objectUrl,
        rect: entry.cropRect ? Object.assign({}, entry.cropRect) : { left: 0, top: 0, right: 100, bottom: 100 },
        previousFocus: previousFocus
      };
      cropImageBox.style.setProperty('--vehicle-crop-aspect', String(Math.max(0.15, probe.naturalWidth / Math.max(1, probe.naturalHeight))));
      cropImage.src = objectUrl;
      cropModal.hidden = false;
      renderVehicleCropRect();
      lockVehicleCropScroll();
      requestAnimationFrame(function () {
        renderVehicleCropRect();
        try { cropDialog && cropDialog.focus(); } catch (error) {}
      });
    };
    probe.onerror = function () {
      URL.revokeObjectURL(objectUrl);
      showError(null, errPhotos, 'Túto fotografiu sa nepodarilo otvoriť na orezanie. Skús JPG alebo PNG.');
    };
    probe.src = objectUrl;
  }

  async function applyVehicleCrop() {
    if (!cropState) return;
    const entry = filesState[cropState.index];
    if (!entry || !entry.file) return;
    const image = cropState.image;
    const rect = cropState.rect;
    const sx = image.naturalWidth * rect.left / 100;
    const sy = image.naturalHeight * rect.top / 100;
    const sw = Math.max(1, image.naturalWidth * (rect.right - rect.left) / 100);
    const sh = Math.max(1, image.naturalHeight * (rect.bottom - rect.top) / 100);
    /* Rovnaká hranica ako pri zmenšovaní po výbere — nech orez nevyrobí
       väčší súbor, než aký by aj tak hneď potom vznikol. */
    const maxSide = AO_MAX_UPLOAD_EDGE;
    let outW = sw;
    let outH = sh;
    if (Math.max(outW, outH) > maxSide) {
      const ratio = maxSide / Math.max(outW, outH);
      outW *= ratio;
      outH *= ratio;
    }
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(outW));
    canvas.height = Math.max(1, Math.round(outH));
    const context = canvas.getContext('2d');
    if (!context) {
      showError(null, errPhotos, 'Orez fotografie sa nepodarilo pripraviť. Skús to znova.');
      return;
    }
    context.drawImage(image, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height);
    const sourceType = String((entry.originalFile || entry.file).type || '').toLowerCase();
    const outputType = sourceType === 'image/png' ? 'image/png' : 'image/jpeg';
    let blob = await new Promise(function (resolve) {
      canvas.toBlob(resolve, outputType, outputType === 'image/jpeg' ? 0.92 : undefined);
    });
    if (!blob) {
      showError(null, errPhotos, 'Orez fotografie sa nepodarilo uložiť. Skús fotografiu nahrať znova.');
      return;
    }
    if (blob.size > 15 * 1024 * 1024 && outputType === 'image/jpeg') {
      const compressed = await new Promise(function (resolve) { canvas.toBlob(resolve, 'image/jpeg', 0.82); });
      if (compressed && compressed.size < blob.size) blob = compressed;
    }
    const baseName = String((entry.originalFile || entry.file).name || 'fotografia').replace(/\.[^.]+$/, '');
    const extension = outputType === 'image/png' ? 'png' : 'jpg';
    const croppedFile = new File([blob], baseName + '-orez.' + extension, { type: outputType, lastModified: Date.now() });
    if (entry.url && entry.url.indexOf('blob:') === 0) {
      try { URL.revokeObjectURL(entry.url); } catch (error) {}
    }
    entry.file = croppedFile;
    entry.compressed = false;
    entry.compressPending = false;
    window.setTimeout(function () { compressEntryPhoto(entry); }, 0);
    entry.name = croppedFile.name;
    entry.url = URL.createObjectURL(croppedFile);
    entry.cropRect = Object.assign({}, rect);
    const croppedIndex = cropState.index;
    syncUploadHiddenFields();
    closeVehicleCrop();
    renderPreviews();
    updateSummary(false);
    updateStepState();
    clearError(null, errPhotos);
    scheduleVehicleDraftSave();
    track('vehicle_photo_cropped', { index: croppedIndex });
  }

  /* FIX 197: ovládanie výrezu na CELEJ ploche fotografie. Stmavené okolie
     výrezu je len `box-shadow`, dotyk nechytá — ťahanie v ňom preto nerobilo
     nič a namiesto orezania sa hýbala stránka. Rovnaká oprava ako v
     konfigurátore trička (assets/ao-shirt-customizer.js). */
  const cropSurface = cropImageBox || cropSelection;
  if (cropSurface) {
    cropSurface.addEventListener('pointerdown', function (event) {
      if (!cropState) return;
      const edgeButton = event.target.closest ? event.target.closest('[data-crop-edge]') : null;
      const insideSelection = Boolean(event.target.closest && event.target.closest('.vehicle-crop-selection'));
      cropAction = edgeButton ? 'edge:' + edgeButton.dataset.cropEdge : 'move';
      cropPointerId = event.pointerId;

      /* Ťuknutie mimo výrezu: výrez skočí pod prst a ťahá sa odtiaľ. */
      if (!edgeButton && !insideSelection) {
        const point = vehicleCropPoint(event);
        const cur = cropState.rect;
        const width = cur.right - cur.left;
        const height = cur.bottom - cur.top;
        const left = clampCrop(point.x - width / 2, 0, 100 - width);
        const top = clampCrop(point.y - height / 2, 0, 100 - height);
        setVehicleCropRect({ left: left, top: top, right: left + width, bottom: top + height });
      }

      cropStartPoint = vehicleCropPoint(event);
      cropStartRect = Object.assign({}, cropState.rect);
      try { cropSurface.setPointerCapture(event.pointerId); } catch (error) {}
      event.preventDefault();
    });
    cropSurface.addEventListener('pointermove', function (event) {
      if (!cropState || event.pointerId !== cropPointerId || !cropAction) return;
      const point = vehicleCropPoint(event);
      const dx = point.x - cropStartPoint.x;
      const dy = point.y - cropStartPoint.y;
      const rect = Object.assign({}, cropStartRect);
      if (cropAction === 'move') {
        const width = rect.right - rect.left;
        const height = rect.bottom - rect.top;
        const left = clampCrop(rect.left + dx, 0, 100 - width);
        const top = clampCrop(rect.top + dy, 0, 100 - height);
        setVehicleCropRect({ left: left, top: top, right: left + width, bottom: top + height });
      } else {
        const edge = cropAction.split(':')[1];
        const min = 8;
        if (edge.indexOf('w') !== -1) rect.left = clampCrop(rect.left + dx, 0, rect.right - min);
        if (edge.indexOf('e') !== -1) rect.right = clampCrop(rect.right + dx, rect.left + min, 100);
        if (edge.indexOf('n') !== -1) rect.top = clampCrop(rect.top + dy, 0, rect.bottom - min);
        if (edge.indexOf('s') !== -1) rect.bottom = clampCrop(rect.bottom + dy, rect.top + min, 100);
        setVehicleCropRect(rect);
      }
      event.preventDefault();
    });
    const endCropPointer = function (event) {
      if (event.pointerId === cropPointerId) {
        cropAction = null;
        cropPointerId = null;
        try { cropSurface.releasePointerCapture(event.pointerId); } catch (error) {}
      }
    };
    cropSurface.addEventListener('pointerup', endCropPointer);
    cropSurface.addEventListener('pointercancel', endCropPointer);
    /* iOS spustí zotrvačný scroll skôr, než sa `touch-action` prejaví. */
    if (cropModal) {
      cropModal.addEventListener('touchmove', function (event) {
        if (cropState && event.cancelable) event.preventDefault();
      }, { passive: false });
    }
  }
  if (cropCancel) cropCancel.addEventListener('click', closeVehicleCrop);
  if (cropApply) cropApply.addEventListener('click', applyVehicleCrop);
  if (cropModal) {
    cropModal.addEventListener('click', function (event) {
      if (event.target === cropModal) closeVehicleCrop();
    });
    cropModal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeVehicleCrop();
      }
    });
  }

  function syncFilesStateFromUploadInput() {
    if (nativeUploadMode || filesState.some(function (file) { return file.source === 'native'; })) return;
    if (uploadEventsActive) return;

    if (suppressUploadedFiles) {
      filesState = [];
      syncUploadHiddenFields();
      setPreviewLoading(false);
      if (preview) preview.innerHTML = '';
      updateStatus();
      updateStepState();
      return;
    }

    const urls = getUploadUrls();

    if (urls.length === 0) {
      const hasAppProcessing =
        document.querySelector('.filepond--item.is-processing') ||
        document.querySelector('.filepond--file-status-main') ||
        document.querySelector('.filepond--file-status-sub');

      if (hasAppProcessing) {
        setPreviewLoading(true);
        updateStatus();
        return;
      }

      filesState = [];
      syncUploadHiddenFields();
      setPreviewLoading(false);
      if (preview) preview.innerHTML = '';
      updateStatus();
      updateSummary(false);
      updateStepState();
      return;
    }

    const newState = urls.map(function (url, index) {
      return {
        id: 'upl_' + index,
        name: 'Fotka ' + (index + 1),
        url: url,
        source: 'upload-lift'
      };
    });

    const oldSignature = filesState.map(function (f) { return f.url; }).join('|');
    const newSignature = newState.map(function (f) { return f.url; }).join('|');

    if (oldSignature === newSignature) {
      setPreviewLoading(false);
      if (filesState.length && preview && !preview.querySelector('.vehicle-file-item')) {
        renderPreviews();
      } else {
        updateStatus();
      }
      return;
    }

    filesState = newState;
    syncUploadHiddenFields();
    setPreviewLoading(false);
    renderPreviews();
    updateSummary(false);
    updateStepState();

    if (attempted && currentStep >= 3) {
      validateStep3(false);
    }
  }

  function bindUploadInputEvents() {
    const input = getUploadInput();
    configureUploadForMultipleFiles(input);
    if (!input || boundUploadInputs.has(input)) return;

    input.addEventListener('change', function () {
      suppressUploadedFiles = false;
      setPreviewLoading(true);
      updateStatus();
      setTimeout(syncFilesStateFromUploadInput, 300);
      setTimeout(syncFilesStateFromUploadInput, 1200);
      setTimeout(syncFilesStateFromUploadInput, 2500);
    });

    boundUploadInputs.add(input);
  }

  function isUploadEventFromCustomizer(e) {
    if (!uploadliftMount || !e || !e.target) return true;
    return e.target === window || e.target === document || uploadliftMount.contains(e.target);
  }


  /* ---------------------------------------------------------------------
     V254 — ZMENŠENIE FOTIEK PRED ODOSLANÍM
     Fotka z telefónu má bežne 4–8 MB a 4000 px. Do košíka sa musí odoslať
     natívnym POSTom (cez AJAX by Shopify uložil iba názov súboru), takže
     zákazník čaká presne toľko, koľko trvá odoslať tie megabajty. Na tlač
     obrazu je 2200 px viac než dosť, takže fotku zmenšíme hneď po výbere —
     kým vypĺňa zvyšok formulára, je to dávno hotové a pridanie do košíka
     je potom otázka sekundy.

     Pri akejkoľvek chybe (HEIC, ktoré prehliadač nevie vykresliť, plátno
     bez kontextu) ostáva pôvodný súbor. Nikdy nezhoršíme to, čo funguje.
     --------------------------------------------------------------------- */
  /* Dlhšia strana po zmenšení.
     Na webe sľubujeme 4K tlač, takže hranica musí byť NAD 4K (3840 px).
     4200 px vychádza na 152 DPI pri 50 × 70 cm, 267 DPI pri 30 × 40
     a 356 DPI pri 21 × 30 — teda nad tlačovým štandardom aj pri najväčšom
     formáte. Bežná fotka z telefónu má 4032 px, takže sa jej to ani
     nedotkne. Zmenšenie zasiahne len naozajstné obry: 48 Mpx režimy
     novších telefónov majú 8160 px a 15–25 MB, a to je presne to, čo
     zákazníka núti čakať minútu. Tam sa reže na 4200 px a stále je to
     viac, než sľubujeme. */
  const AO_MAX_UPLOAD_EDGE = 4200;
  const AO_COMPRESS_MIN_BYTES = 2500 * 1024;

  function compressEntryPhoto(entry) {
    if (!entry || !entry.file || entry.compressPending || entry.compressed) return;
    const source = entry.file;
    if (!/^image\/(jpeg|png|webp)$/i.test(String(source.type || ''))) return;
    if (source.size < AO_COMPRESS_MIN_BYTES) { entry.compressed = true; return; }

    entry.compressPending = true;
    const url = URL.createObjectURL(source);
    const img = new Image();
    img.onload = function () {
      try {
        const scale = Math.min(1, AO_MAX_UPLOAD_EDGE / Math.max(img.naturalWidth, img.naturalHeight));
        if (scale >= 1) { entry.compressed = true; entry.compressPending = false; URL.revokeObjectURL(url); return; }
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(img.naturalWidth * scale);
        canvas.height = Math.round(img.naturalHeight * scale);
        const ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('no-2d-context');
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(function (blob) {
          URL.revokeObjectURL(url);
          entry.compressPending = false;
          entry.compressed = true;
          if (!blob || blob.size >= source.size) return;
          try {
            const name = String(entry.name || source.name || 'fotka').replace(/\.[^.]+$/, '') + '.jpg';
            entry.file = new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() });
            track('vehicle_photo_compressed', {
              before_kb: Math.round(source.size / 1024),
              after_kb: Math.round(blob.size / 1024)
            });
          } catch (error) { /* File konštruktor nie je všade — necháme originál */ }
        }, 'image/jpeg', 0.92);
      } catch (error) {
        URL.revokeObjectURL(url);
        entry.compressPending = false;
        entry.compressed = true;
      }
    };
    img.onerror = function () {
      URL.revokeObjectURL(url);
      entry.compressPending = false;
      entry.compressed = true;
    };
    img.src = url;
  }

  function isThumbnailUpload(file) {
    return !!(file && file.meta && file.meta.variant === 'thumbnail');
  }

  function handleUploadAdded(e) {
    if (!isUploadEventFromCustomizer(e)) return;

    const file = e.detail || {};
    if (!file.url || isThumbnailUpload(file)) return;

    uploadEventsActive = true;
    suppressUploadedFiles = false;

    const id = String(file.id || file.key || file.url);
    const name = file.name || file.filename || (file.meta && file.meta.name) || ('Fotka ' + (filesState.length + 1));
    const existingIndex = filesState.findIndex(function (item) {
      return item.url === file.url || item.id === id;
    });

    const normalizedFile = { id: id, name: name, url: file.url, source: 'upload-lift' };
    if (existingIndex > -1) {
      filesState[existingIndex] = normalizedFile;
    } else if (filesState.length < 10) {
      filesState.push(normalizedFile);
    }

    syncUploadHiddenFields();
    setPreviewLoading(false);
    renderPreviews();
    updateSummary(false);
    updateStepState();
    clearError(null, errPhotos);
  }

  function handleUploadRemoved(e) {
    if (!isUploadEventFromCustomizer(e)) return;

    const file = e.detail || {};
    if (isThumbnailUpload(file)) return;

    uploadEventsActive = true;
    filesState = filesState.filter(function (item) {
      if (file.url && item.url === file.url) return false;
      if (file.id && item.id === String(file.id)) return false;
      return true;
    });

    syncUploadHiddenFields();
    setPreviewLoading(false);
    renderPreviews();
    updateSummary(false);
    updateStepState();
  }

  function startUploadPolling() {
    stopUploadPolling();
    let attempts = 0;
    const tick = function () {
      attempts += 1;
      moveRealUploaderIntoBox();
      bindUploadInputEvents();
      configureUploadForMultipleFiles(getUploadInput());
      syncFilesStateFromUploadInput();

      const input = getUploadInput();
      if (input) {
        if (!filesState.some(function (file) { return file.source === 'native'; })) setNativeFallbackActive(false);
        stopUploadPolling();
      } else if (attempts >= 12) {
        setNativeFallbackActive(true);
        stopUploadPolling();
        track('vehicle_upload_fallback_available', {});
      }
    };

    tick();
    if (!getUploadInput()) {
      uploadPollInterval = window.setInterval(tick, 500);
    }
  }

  function clearNativeFiles() {
    filesState.forEach(function (file) {
      if (file.source === 'native' && file.url && file.url.indexOf('blob:') === 0) {
        URL.revokeObjectURL(file.url);
      }
    });
    if (nativeUploadInput) {
      try { nativeUploadInput.value = ''; } catch (error) {}
    }
  }

  function bindNativeUpload() {
    if (!nativeUploadInput || nativeUploadBound) return;
    nativeUploadBound = true;
    nativeUploadInput.addEventListener('change', function () {
      const selected = Array.from(nativeUploadInput.files || []);
      const picked = selected.slice(0, MAX_NATIVE_FILES);
      const accepted = picked.filter(function (file) {
        if (!file || file.size > MAX_NATIVE_FILE_BYTES) return false;
        const isImageMime = NATIVE_MIME_ALLOWLIST.has(String(file.type || '').toLowerCase());
        const hasImageExtension = /\.(jpe?g|png|webp|heic|heif)$/i.test(String(file.name || ''));
        return hasImageExtension && (!file.type || isImageMime);
      });

      if (!accepted.length) {
        showError(null, errPhotos, 'Skús JPG alebo PNG do 20 MB. HEIC z iPhonu môže v niektorých prehliadačoch robiť problém.');
        track('vehicle_upload_failed', { reason: 'invalid_native_file' });
        try { nativeUploadInput.value = ''; } catch (error) {}
        return;
      }

      // Keep already uploaded photos when the customer adds another file later.
      // This is important for a main car photo + optional logo/reference image.
      setNativeFallbackActive(true);
      uploadEventsActive = false;
      suppressUploadedFiles = false;
      const availableSlots = Math.max(0, MAX_NATIVE_FILES - filesState.length);
      const additions = accepted.slice(0, availableSlots).map(function (file, index) {
        return {
          id: 'native_' + Date.now() + '_' + index,
          name: file.name || ('Fotografia ' + (filesState.length + index + 1)),
          url: URL.createObjectURL(file),
          source: 'native',
          file: file,
          originalFile: file
        };
      });
      const firstNewIndex = filesState.length;
      filesState = filesState.concat(additions);
      /* Zmenšenie beží na pozadí, hneď po výbere fotky. */
      additions.forEach(function (entry) {
        window.setTimeout(function () { compressEntryPhoto(entry); }, 0);
      });

      syncUploadHiddenFields();
      setPreviewLoading(false);
      renderPreviews();
      updateSummary(false);
      updateStepState();
      clearError(null, errPhotos);
      const rejectedCount = Math.max(0, selected.length - additions.length);
      if (rejectedCount > 0) {
        showError(null, errPhotos, `${additions.length} fotografií bolo pridaných, ${rejectedCount} nebolo prijatých. Limit je ${MAX_NATIVE_FILES} súborov, 20 MB na súbor; podporované sú JPG, PNG, WebP a HEIC/HEIF.`);
      }
      track('vehicle_upload_fallback_used', { count: filesState.length });
      if (additions.length === 1) {
        window.setTimeout(function () { openVehicleCrop(firstNewIndex); }, 80);
      }
    });
  }

  // Bind as soon as DOMContentLoaded runs; large product media must not delay upload.
  bindNativeUpload();
  setNativeFallbackActive(true);

  function moveRealUploaderIntoBox() {
    if (!uploadliftMount) return;

    const prepared = prepareRealUploader();
    const candidate = prepared.root;

    if (!candidate) return;

    if (uploadliftMount.contains(candidate)) return;

    uploadliftMount.innerHTML = '';
    uploadliftMount.appendChild(candidate);
    candidate.classList.remove('vehicle-upload-source');
  }

  function updateSummaryPrice() {
    const p = getPriceData();

    if (!p) {
      summaryPriceEl.textContent = '-';
      summaryOldPriceEl.textContent = ' ';
      summaryOldPriceEl.style.visibility = 'hidden';
      summarySaveEl.textContent = '';
      summarySaveEl.style.display = 'none';
      return;
    }

    summaryPriceEl.textContent = fmt(p.now);

    if (p.old && p.old > p.now) {
      summaryOldPriceEl.textContent = fmt(p.old);
      summaryOldPriceEl.style.visibility = 'visible';
      summarySaveEl.textContent = 'Ušetríš ' + fmt(p.old - p.now);
      summarySaveEl.style.display = '';
    } else {
      summaryOldPriceEl.textContent = ' ';
      summaryOldPriceEl.style.visibility = 'hidden';
      summarySaveEl.textContent = '';
      summarySaveEl.style.display = 'none';
    }
  }

  function updateSizeCardPrices() {
    const frameValue = currentFrameValue();

    root.querySelectorAll('input[name="custom_size"]').forEach(function (input) {
      const card = input.closest('.size-card');
      if (!card) return;

      const oldEl = card.querySelector('.size-old');
      const newEl = card.querySelector('.size-new');
      const saveEl = card.querySelector('.size-save');
      const p = getPriceData(frameValue, input.value);
      const available = !!(p && p.available);

      input.disabled = !available;
      card.classList.toggle('is-unavailable', !available);
      card.setAttribute('aria-disabled', available ? 'false' : 'true');

      if (!oldEl || !newEl) return;
      if (!p) {
        newEl.textContent = 'Nedostupné';
        oldEl.textContent = ' ';
        oldEl.style.visibility = 'hidden';
        if (saveEl) { saveEl.textContent = ''; saveEl.style.display = 'none'; }
        return;
      }

      newEl.textContent = available ? fmt(p.now) : 'Vypredané';
      if (p.old && p.old > p.now) {
        oldEl.textContent = fmt(p.old);
        oldEl.style.visibility = 'visible';
        if (saveEl) {
          saveEl.textContent = 'Ušetríš ' + fmt(p.old - p.now);
          saveEl.style.display = available ? 'block' : 'none';
        }
      } else {
        oldEl.textContent = ' ';
        oldEl.style.visibility = 'hidden';
        if (saveEl) saveEl.style.display = 'none';
      }
    });

    const selected = root.querySelector('input[name="custom_size"]:checked');
    if (!selected || selected.disabled) {
      const preferred = root.querySelector('input[name="custom_size"][value="A3"]:not(:disabled)');
      const firstAvailable = preferred || root.querySelector('input[name="custom_size"]:not(:disabled)');
      if (firstAvailable) firstAvailable.checked = true;
    }
  }

  function buildSummaryThumbsHtml() {
    if (sumPhotoCount) sumPhotoCount.textContent = String(filesState.length);
    if (sumPhotoNames) sumPhotoNames.textContent = filesState.length ? filesState.map(function (f) { return f.name || 'Fotografia'; }).join(', ') : '-';
    summaryThumbHtml = '';
  }

  function paintSummaryThumbsFromCache() {
    if (sumPhotoCount) sumPhotoCount.textContent = String(filesState.length);
    if (sumPhotoNames) sumPhotoNames.textContent = filesState.length ? filesState.map(function (f) { return f.name || 'Fotografia'; }).join(', ') : '-';
  }

  function updateSummaryVisuals() {
    const firstPhoto = filesState.find(function (file) { return file && file.url; });
    if (sumPhotoPreviewImage) {
      if (firstPhoto && firstPhoto.url) {
        sumPhotoPreviewImage.src = firstPhoto.url;
        sumPhotoPreviewImage.hidden = false;
        if (sumPhotoEmpty) sumPhotoEmpty.hidden = true;
      } else {
        sumPhotoPreviewImage.removeAttribute('src');
        sumPhotoPreviewImage.hidden = true;
        if (sumPhotoEmpty) sumPhotoEmpty.hidden = false;
      }
    }

    const selectedDesignInput = root.querySelector('input[name="properties[Dizajn]"]:checked');
    const designImage = selectedDesignInput ? selectedDesignInput.dataset.designImage : '';
    if (sumDesignPreviewImage) {
      if (designImage) {
        sumDesignPreviewImage.src = designImage;
        sumDesignPreviewImage.alt = selectedDesignInput.dataset.designAlt || 'Vybraný referenčný dizajn';
        sumDesignPreviewImage.hidden = false;
        if (sumDesignPreviewNumber) sumDesignPreviewNumber.hidden = true;
      } else {
        sumDesignPreviewImage.removeAttribute('src');
        sumDesignPreviewImage.hidden = true;
        if (sumDesignPreviewNumber) {
          sumDesignPreviewNumber.hidden = false;
          sumDesignPreviewNumber.textContent = selectedDesignInput ? 'Tvoja grafika' : 'Vyber dizajn';
        }
      }
    }
  }

  function updateSummaryRows() {
    const noteValue = (noteEl.value || '').trim();
    const selectedDesign = getSelectedDesign();
    const designMode = getDesignMode();
    const know = isKnowMode();
    const subjectValue = (subjectEl.value || '').trim();
    const engineCodeValue = (engineCodeEl && engineCodeEl.value || '').trim();
    const yearValue = (yearEl.value || '').trim();
    const engineValue = (engineEl.value || '').trim();
    const kwValue = (kwEl.value || '').trim();
    const spzValue = (spzEl.value || '').trim();
    const spzCountry = spzCountryEl ? spzCountryEl.value : 'SK';
    const spzFlag = spzCountry === 'CZ' ? '🇨🇿 CZ' : '🇸🇰 SK';

    // CRO V220: rám je súčasťou ceny, zhrnutie to má potvrdiť, nie pôsobiť ako voľba.
    sumFrame.textContent = (frameLabelFromValue(currentFrameValue()) || 'S rámom') + ' · v cene';
    sumSize.textContent = baseSizeFromValue(currentPickedValue()) || '-';
    sumDesign.textContent = selectedDesign || '-';
    sumMode.textContent = getStep2ModeLabel();
    if (sumModeRow) sumModeRow.classList.toggle('is-hidden', designMode !== 'car');
    if (sumBgRow) sumBgRow.classList.toggle('is-hidden', designMode === 'engine' || designMode === 'user_design');
    sumBg.textContent = designMode === 'engine' || designMode === 'user_design' ? '-' : (getSelectedBackgroundMode() || '-');

    if (sumSubjectRow) {
      const showSubject = designMode === 'user_design'
        ? false
        : designMode === 'car'
        ? (know || !!subjectValue)
        : (designMode !== 'engine' || !!subjectValue);
      sumSubjectRow.classList.toggle('is-hidden', !showSubject);
      if (sumSubjectKey) sumSubjectKey.textContent = designMode === 'engine' ? 'Model / generácia' : 'Typ / model auta';
      sumSubject.textContent = safeText(subjectValue);
    }

    const showKnownTech = designMode === 'car' && know;
    const showUnknownSpz = designMode === 'car' && !know;
    const showEngineTech = designMode === 'engine';
    sumYearRow.classList.toggle('is-hidden', !(showKnownTech && yearValue));
    sumEngineRow.classList.toggle('is-hidden', !((showKnownTech || showEngineTech) && engineValue));
    sumKwRow.classList.toggle('is-hidden', !((showKnownTech || showEngineTech) && kwValue));
    sumSpzRow.classList.toggle('is-hidden', !(designMode === 'car' && spzValue));
    if (sumEngineCodeRow) sumEngineCodeRow.classList.toggle('is-hidden', !(showEngineTech && engineCodeValue));
    if (sumEngineKey) sumEngineKey.textContent = showEngineTech ? 'Typ motora' : 'Motor';
    if (sumKwKey) sumKwKey.textContent = 'Výkon';
    sumYear.textContent = safeText(yearValue);
    sumEngine.textContent = safeText(engineValue);
    sumKw.textContent = safeText(kwValue);
    sumSpz.textContent = spzValue ? `${spzFlag} · ${spzValue}` : '-';
    if (sumEngineCode) sumEngineCode.textContent = safeText(engineCodeValue);

    if (noteValue) {
      sumNoteRow.classList.remove('is-hidden');
      sumNote.textContent = noteValue;
    } else {
      sumNoteRow.classList.add('is-hidden');
      sumNote.textContent = '-';
    }

    updateSummaryVisuals();
  }

  function isValidYear(v) {
    return /^[0-9]{4}$/.test((v || '').trim());
  }

  function normalizeSpz(v) {
    return (v || '').toUpperCase().replace(/[\s-]+/g, '').trim();
  }

  function isValidSpz(v, countryCode) {
    return nonEmpty(v);
  }

  function technicalDataComplete() {
    return isValidYear(yearEl ? yearEl.value : '') && nonEmpty(engineEl ? engineEl.value : '') && nonEmpty(kwEl ? kwEl.value : '');
  }

  function validSpzProvided() {
    return isValidSpz(spzEl ? spzEl.value : '', spzCountryEl ? spzCountryEl.value : 'SK');
  }

  function requirementStar() {
    return '<span class="field-required" aria-hidden="true">*</span>';
  }

  function optionalLabel() {
    return '<span class="field-label__optional">(voliteľné)</span>';
  }

  function updateVehicleRequirementLabels() {
    const designMode = getDesignMode();
    const know = isKnowMode();
    const spzLabel = spzBlock ? spzBlock.querySelector('.field-label') : null;

    if (designMode === 'user_design') return;

    if (designMode === 'title_only') {
      if (subjectLabel) subjectLabel.innerHTML = 'Aké auto to je? ' + requirementStar();
      return;
    }

    if (designMode === 'engine') {
      if (subjectLabel) subjectLabel.innerHTML = 'Model auta / generácia ' + optionalLabel();
      if (engineLabel) engineLabel.innerHTML = 'Typ motora ' + requirementStar();
      if (kwLabel) kwLabel.innerHTML = 'Výkon ' + optionalLabel();
      if (engineCodeField) {
        const codeLabel = engineCodeField.querySelector('.field-label');
        if (codeLabel) codeLabel.innerHTML = 'Kód motora ' + optionalLabel();
      }
      return;
    }

    if (subjectLabel) subjectLabel.innerHTML = 'Aké auto to je? ' + optionalLabel();
    if (spzLabel) spzLabel.innerHTML = 'SPZ / EČV ' + requirementStar();
    if (yearLabel) yearLabel.innerHTML = 'Rok výroby ' + optionalLabel();
    if (engineLabel) engineLabel.innerHTML = 'Motor ' + optionalLabel();
    if (kwLabel) kwLabel.innerHTML = 'Výkon ' + optionalLabel();
    if (engineCodeField) {
      const codeLabel = engineCodeField.querySelector('.field-label');
      if (codeLabel) codeLabel.innerHTML = 'Kód motora ' + optionalLabel();
    }
  }

  function getCompletionStatus() {
    const designMode = getDesignMode();
    const variant = getSelectedVariant();
    const tasks = [];
    if (designMode !== 'engine') {
      tasks.push({ key: 'photos', label: designMode === 'user_design' ? 'hotová grafika' : 'fotka auta', done: filesState.length > 0 });
      if (designMode !== 'user_design') tasks.push({ key: 'background', label: 'pozadie', done: !!getSelectedBackgroundMode() });
    }
    tasks.push({ key: 'design', label: 'dizajn', done: !!getSelectedDesign() });
    tasks.push({ key: 'size', label: 'veľkosť', done: !!currentPickedValue() });
    tasks.push({ key: 'frame', label: 'rám', done: !!currentFrameValue() && !!variant && variant.available !== false });
    if (designMode !== 'user_design') tasks.push({ key: 'vehicle', label: 'údaje', done: isStep4Complete() });
    const doneCount = tasks.filter(function (item) { return item.done; }).length;
    const percent = tasks.length ? Math.round(doneCount / tasks.length * 100) : 0;
    const missing = tasks.filter(function (item) { return !item.done; }).map(function (item) { return item.label; });
    return { total: tasks.length, doneCount: doneCount, percent: percent, missing: missing, complete: doneCount === tasks.length };
  }

  function clearCelebrationClasses() {
    [progressWrap, progressStickyWrap].forEach(function (el) {
      if (!el) return;
      el.classList.remove('is-celebrating');
    });
  }

  function startCelebration() {
    clearCelebrationClasses();

    [progressWrap, progressStickyWrap].forEach(function (el) {
      if (!el) return;
      el.classList.add('is-celebrating');
    });

    clearTimeout(celebrationTimeout);
    celebrationTimeout = setTimeout(clearCelebrationClasses, 950);
  }

  function setCollapsedState(isComplete) {
    [progressWrap, progressStickyWrap].forEach(function (el) {
      if (!el) return;
      el.classList.toggle('is-collapsed', !!isComplete);
      el.classList.toggle('is-complete', !!isComplete);
    });
  }

  function applyProgressStateToElements(percent, complete, stateText, bottomText) {
    if (progressFill) progressFill.style.width = percent + '%';
    if (progressPercent) progressPercent.textContent = percent + '%';
    if (progressState) progressState.textContent = stateText;
    if (progressBottom) progressBottom.textContent = bottomText;

    if (progressStickyFill) progressStickyFill.style.width = percent + '%';
    if (progressStickyPercent) progressStickyPercent.textContent = percent + '%';
    if (progressStickyState) progressStickyState.textContent = stateText;
    if (progressStickyBottom) progressStickyBottom.textContent = bottomText;

    setCollapsedState(complete);
  }

  function updateProgressBar() {
    const progress = getCompletionStatus();
    const percent = Math.max(0, Math.min(100, progress.percent));
    const firstMissing = progress.missing[0] || '';
    const labels = {
      'fotka auta': 'Nahraj fotku auta',
      'hotová grafika': 'Nahraj hotovú grafiku',
      'pozadie': 'Vyber úpravu pozadia',
      'dizajn': 'Vyber dizajn',
      'veľkosť': 'Vyber veľkosť',
      'rám': 'Vyber rám',
      'typ a model auta': 'Napíš typ a model auta',
      'typ motora': 'Napíš typ motora'
    };

    if (progress.complete) {
      applyProgressStateToElements(100, true, 'Hotovo', 'Všetko je pripravené. Môžeš pridať obraz do košíka.');
      if (!lastCompleteState) startCelebration();
      lastCompleteState = true;
      return;
    }

    const stateText = labels[firstMissing] || 'Dokonči konfiguráciu';
    const bottomText = 'Chýba: ' + progress.missing.join(', ');
    applyProgressStateToElements(percent, false, stateText, bottomText);
    lastCompleteState = false;
    clearCelebrationClasses();
  }

  function getHeaderHeight() {
    const selectors = [
      '#shopify-section-header.is-savor-fixed',
      '#shopify-section-header',
      '.shopify-section-header.is-savor-fixed',
      '.shopify-section-header',
      '.header-wrapper.is-savor-fixed',
      '.header-wrapper',
      '.header.is-savor-fixed',
      '.header'
    ];

    for (let i = 0; i < selectors.length; i++) {
      const el = document.querySelector(selectors[i]);
      if (el && el.offsetHeight) return el.offsetHeight;
    }

    return window.innerWidth <= 520 ? 64 : 80;
  }

  function updateStickyTopOffset() {
    const top = getHeaderHeight() + 8;
    document.documentElement.style.setProperty('--vehicle-sticky-top', top + 'px');
  }

  function scrollToSuccessBox() {
    /* V230: po pridaní do košíka sa zobrazí krok 5, ktorý je na konci
       konfigurátora — používateľ tak skončil úplne dole na stránke.
       Potvrdenie mu teraz vycentrujeme pred oči. */
    var box = document.querySelector('#step_success .success-box') || document.getElementById('step_success');
    if (!box) return;
    var rect = box.getBoundingClientRect();
    var top = (window.scrollY || document.documentElement.scrollTop || 0) + rect.top - Math.max(16, (window.innerHeight - rect.height) / 2);
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function scrollToPageTopSection() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  function scrollToProgressBar() {
    if (!progressWrap) return;

    const y = progressWrap.getBoundingClientRect().top + window.scrollY - getHeaderHeight() - 12;

    window.scrollTo({
      top: Math.max(0, y),
      behavior: 'smooth'
    });
  }

  function updateStickyProgressVisibility() {
    if (!progressWrap || !progressStickyWrap) return;

    const rect = progressWrap.getBoundingClientRect();
    const headerHeight = getHeaderHeight();
    const shouldShow = rect.bottom < headerHeight + 8;

    progressStickyWrap.classList.toggle('is-visible', shouldShow);

    if (stickyBackButton) {
      const backButtons = { 2: btnBack1, 3: btnBack2, 4: btnBack3 };
      const realBackButton = backButtons[currentStep] || null;
      let realBackVisible = false;

      if (realBackButton) {
        const backRect = realBackButton.getBoundingClientRect();
        realBackVisible = backRect.bottom > headerHeight && backRect.top < window.innerHeight;
      }

      stickyBackButton.classList.toggle(
        'is-visible',
        shouldShow && currentStep >= 2 && currentStep <= 4 && !realBackVisible
      );
    }
  }

  function openSpecialDesignModal() {
    if (!specialDesignModal) return;
    specialDesignModal.classList.add('is-open');
    specialDesignModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('special-design-modal-open');
    const closeButton = specialDesignModal.querySelector('.special-design-modal__close');
    if (closeButton) closeButton.focus();
  }

  function closeSpecialDesignModal() {
    if (!specialDesignModal) return;
    specialDesignModal.classList.remove('is-open');
    specialDesignModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('special-design-modal-open');
    if (openSpecialDesignModalButton) openSpecialDesignModalButton.focus();
  }


  function updateLiveMockup() {
    // V63 intentionally has no generated poster preview.
  }

  function vehicleDraftPayload() {
    const radios = {};
    root.querySelectorAll('input[type="radio"]:checked').forEach(input => { if (input.name) radios[input.name] = input.value; });
    const values = {};
    /* SPZ, voľná poznámka a upload URL sa neukladajú do dlhodobého storage. */
    [subjectEl, yearEl, engineEl, kwEl, engineCodeEl, spzCountryEl].forEach(input => { if (input?.id) values[input.id] = input.value || ''; });
    return {
      version: 66, savedAt: Date.now(), radios, values, technicalOpen: Boolean(technicalDetails?.open),
      files: []
    };
  }

  function saveVehicleDraftNow() {
    if (restoringDraft) return;
    try { localStorage.setItem(DRAFT_KEY, JSON.stringify(vehicleDraftPayload())); } catch (_) {}
  }

  function scheduleVehicleDraftSave() {
    if (restoringDraft) return;
    clearTimeout(draftSaveTimer);
    draftSaveTimer = setTimeout(saveVehicleDraftNow, 220);
  }

  function readVehicleDraft() {
    try {
      const raw = localStorage.getItem(DRAFT_KEY);
      if (!raw) return null;
      const draft = JSON.parse(raw);
      if (!draft?.savedAt || Date.now() - draft.savedAt > DRAFT_MAX_AGE) { localStorage.removeItem(DRAFT_KEY); return null; }
      return draft;
    } catch (_) { return null; }
  }

  function clearVehicleDraft() {
    clearTimeout(draftSaveTimer);
    try { localStorage.removeItem(DRAFT_KEY); } catch (_) {}
    if (draftResume) draftResume.hidden = true;
  }

  function restoreVehicleDraft(draft) {
    if (!draft) return;
    restoringDraft = true;
    try {
      Object.entries(draft.radios || {}).forEach(([name, value]) => {
        const inputs = [...root.querySelectorAll(`input[type="radio"][name="${CSS.escape(name)}"]`)];
        const match = inputs.find(input => input.value === value);
        if (match) match.checked = true;
      });
      Object.entries(draft.values || {}).forEach(([id, value]) => { const input = document.getElementById(id); if (input) input.value = value; });
      if (technicalDetails) technicalDetails.open = Boolean(draft.technicalOpen);
      if (Array.isArray(draft.files) && draft.files.length) {
        filesState = draft.files.map((file, index) => ({ ...file, id: file.id || `draft_${index}` }));
        uploadEventsActive = true;
        suppressUploadedFiles = false;
        syncUploadHiddenFields();
      }
      applySelection();
      setModeUI();
      renderPreviews();
      updateSummary(false);
      updateStepState();
      updateLiveMockup();
    } finally {
      restoringDraft = false;
      scheduleVehicleDraftSave();
    }
  }

  function updatePurchaseBar() {
    if (!purchaseBar) {
      document.documentElement.classList.remove('ao-has-purchase-bar');
      return;
    }
    document.documentElement.classList.toggle('ao-has-purchase-bar', !purchaseBar.hidden);
    const pricing = getPriceData();
    if (purchasePrice) purchasePrice.textContent = pricing ? fmt(pricing.now) : '—';
    const progress = getCompletionStatus();
    const missingCore = [];
    if (getDesignMode() !== 'engine' && filesState.length === 0) missingCore.push(getDesignMode() === 'user_design' ? 'hotová grafika' : 'fotka auta');
    if (!getSelectedDesign()) missingCore.push('dizajn');
    if (getDesignMode() !== 'user_design' && !isStep4Complete()) missingCore.push('údaje');
    if (purchaseMissing) {
      purchaseMissing.textContent = progress.complete
        ? 'Všetko pripravené na objednanie'
        : `Chýba: ${missingCore.join(', ') || 'dokonči konfiguráciu'}`;
    }
    if (purchaseBreakdown) {
      const size = baseSizeFromValue(currentPickedValue()) || 'veľkosť nevybraná';
      const frame = frameLabelFromValue(currentFrameValue()) || 'rám nevybraný';
      purchaseBreakdown.textContent = `${size} · ${frame}${pricing ? ` · spolu ${fmt(pricing.now)}` : ''}`;
    }
    if (purchaseAdd) {
      purchaseAdd.disabled = false;
      purchaseAdd.classList.toggle('is-incomplete', !progress.complete);
      purchaseAdd.textContent = progress.complete
        ? 'Pridať do košíka'
        : (filesState.length ? 'Dokonči údaje' : 'Nahraj fotku auta');
    }
  }

  function updateSummary(lightMode) {
    updateSizeCardPrices();
    updateSummaryPrice();
    updateSummaryRows();
    updateStickyTopOffset();
    updateProgressBar();
    updateStickyProgressVisibility();
    updateLiveMockup();
    updatePurchaseBar();
    scheduleVehicleDraftSave();

    if (lightMode) {
      paintSummaryThumbsFromCache();
    } else {
      buildSummaryThumbsHtml();
    }
  }

  function showError(input, errEl, msg) {
    if (input) input.classList.add('input-invalid');
    if (errEl) {
      errEl.textContent = msg;
      errEl.style.display = 'block';
    }
  }

  function clearError(input, errEl) {
    if (input) input.classList.remove('input-invalid');
    if (errEl) {
      errEl.textContent = '';
      errEl.style.display = 'none';
    }
  }

  function updateSpzCountryUI() {
    if (!spzEl) return;
    const country = spzCountryEl ? spzCountryEl.value : 'SK';
    spzEl.placeholder = country === 'CZ' ? 'napr. 1AB 2345' : 'napr. BA123AB';
    spzEl.value = (spzEl.value || '').toUpperCase();
  }

  function setModeUI() {
    const designMode = getDesignMode();
    const know = isKnowMode();
    const isTitleOnly = designMode === 'title_only';
    const isEngine = designMode === 'engine';
    const isCar = designMode === 'car';
    const isUserDesign = designMode === 'user_design';

    if (step2Title) step2Title.textContent = isUserDesign ? 'Doplň špeciálne požiadavky' : (isTitleOnly ? 'Doplň názov auta' : (isEngine ? 'Doplň údaje o motore' : 'Doplň údaje, ktoré chceš na obraze'));
    if (step2Subtitle) {
      step2Subtitle.textContent = isUserDesign
        ? 'Tvoju hotovú grafiku vytlačíme bez prerábania. Sem môžeš dopísať požiadavku k tlači.'
        : isTitleOnly
        ? 'Pri tomto dizajne stačí typ a model auta.'
        : (isEngine
          ? 'Povinný je typ motora. Ostatné údaje môžeš doplniť, ak ich poznáš.'
          : (know ? 'Vyplň údaje, ktoré chceš mať na obraze.' : 'Stačí SPZ / EČV. Názov auta môžeš doplniť, ak ho poznáš.'));
    }

    if (modeBlock) modeBlock.classList.toggle('is-hidden', !isCar);
    if (modeLabel) modeLabel.textContent = 'Poznáš údaje o aute?';
    if (modeNotice) modeNotice.classList.add('is-hidden');

    if (subjectField) subjectField.classList.toggle('is-hidden', isUserDesign);
    if (subjectEl) subjectEl.placeholder = isEngine ? 'napr. Audi A4 B6' : 'napr. Škoda Octavia';
    if (subjectHelp) { subjectHelp.textContent = ''; subjectHelp.hidden = true; }

    /* V298: ŠPZ je jediný povinný údaj pri aute, preto je viditeľná vždy. */
    if (spzBlock) spzBlock.classList.toggle('is-hidden', !isCar);
    if (dataBlock) dataBlock.classList.toggle('is-hidden', isUserDesign || isTitleOnly || (isCar && !know));
    if (yearField) yearField.classList.toggle('is-hidden', !isCar || !know);
    if (engineField) engineField.classList.toggle('is-hidden', isTitleOnly || (isCar && !know));
    if (kwField) kwField.classList.toggle('is-hidden', isTitleOnly || (isCar && !know));
    if (engineCodeField) engineCodeField.classList.toggle('is-hidden', !isEngine);

    if (kwEl) kwEl.placeholder = isEngine ? 'napr. 81 kW alebo 110 hp' : 'napr. 110 kW / 150 hp';
    if (engineEl) engineEl.placeholder = isEngine ? 'napr. 1.9 TDI' : 'napr. 2.0 TDI';
    if (kwHelp) kwHelp.innerHTML = isEngine
      ? 'Ak výkon poznáš, uveď aj jednotku, napríklad <strong>kW</strong> alebo <strong>hp</strong>.'
      : 'Uveď aj jednotku, napríklad <strong>kW</strong> alebo <strong>hp</strong>.';

    if (step3Title) step3Title.textContent = isUserDesign ? 'Nahraj svoju hotovú grafiku' : (isEngine ? 'Fotografia motora' : 'Nahraj fotografiu auta');
    if (step3Subtitle) step3Subtitle.textContent = isUserDesign
      ? 'Nahraj čo najkvalitnejší súbor grafiky, ktorý máme priamo vytlačiť.'
      : isEngine
      ? 'Fotografiu motora môžeš pridať, ak ju máš.'
      : 'Nahraj čo najkvalitnejšiu fotografiu, na ktorej je vidieť aspoň 70 % auta.';
    if (uploadCardTitle) uploadCardTitle.textContent = isUserDesign ? 'Nahrať hotovú grafiku' : (isEngine ? 'Nahrať fotografiu motora' : 'Nahrať fotografiu auta');
    if (uploadCardText) uploadCardText.textContent = '';
    if (uploadCardMeta) uploadCardMeta.textContent = isEngine ? 'JPG, PNG alebo HEIC · voliteľné' : 'JPG, PNG alebo HEIC';
    if (backgroundField) backgroundField.classList.toggle('is-hidden', isEngine || isUserDesign);
    if (uploadLogoNotice) uploadLogoNotice.classList.toggle('is-hidden', isEngine || isUserDesign);

    updateSpzCountryUI();
    updateVehicleRequirementLabels();
    clearError(subjectEl, errSubject);
    clearError(yearEl, errYear);
    clearError(engineEl, errEngine);
    clearError(kwEl, errKw);
    clearError(engineCodeEl, errEngineCode);
    clearError(spzEl, errSpz);
    updateStatus();
    updateLiveMockup();
    updateSummary(true);
  }

  function applySelection() {
    updateSizeCardPrices();
    const frameValue = currentFrameValue();
    const sizeValue = currentPickedValue();

    if (frameProperty) frameProperty.value = frameLabelFromValue(frameValue);
    if (sizeProperty) sizeProperty.value = baseSizeFromValue(sizeValue);

    updateSummary(true);
  }

  function isStep1Complete() {
    if (getDesignMode() === 'engine') return true;
    if (getDesignMode() === 'user_design') return filesState.length > 0;
    return filesState.length > 0 && !!getSelectedBackgroundMode();
  }

  function isStep2Complete() {
    return !!getSelectedDesign();
  }

  function isStep3Complete() {
    const variant = getSelectedVariant();
    return !!currentPickedValue() && !!currentFrameValue() && !!variant && variant.available !== false;
  }

  function isStep4Complete() {
    const designMode = getDesignMode();
    if (designMode === 'user_design') return true;
    if (designMode === 'title_only') return nonEmpty(subjectEl ? subjectEl.value : '');
    if (designMode === 'engine') return nonEmpty(engineEl ? engineEl.value : '');
    /* V298: povinná je len ŠPZ, ostatné údaje sú nepovinné. */
    return validSpzProvided();
  }

  function paintStep(el, complete) {
    if (!el) return;
    el.classList.toggle('is-complete', !!complete);
  }

  function updateStepState() {
    paintStep(step1Number, isStep1Complete());
    paintStep(step2Number, isStep2Complete());
    paintStep(step3Number, isStep3Complete());
    paintStep(step4Number, isStep4Complete());
    updateStickyTopOffset();
    updateProgressBar();
    updateStickyProgressVisibility();
  }

  function scrollToCustomizerStep(stepNumber) {
    const target = stepEls[stepNumber];
    if (!target) return;
    const headerOffset = Math.max(88, parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 88);
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset - 34;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function validateStep1(scrollToFirstInvalid) {
    let ok = true;
    const designMode = getDesignMode();
    const engineMode = designMode === 'engine';
    const userDesignMode = designMode === 'user_design';
    if (!engineMode && filesState.length === 0) {
      ok = false;
      showError(null, errPhotos, userDesignMode ? 'Nahraj hotovú grafiku, ktorú máme vytlačiť.' : 'Nahraj aspoň 1 fotku auta. Ak HEIC z iPhonu neprejde, skús JPG alebo PNG.');
    } else clearError(null, errPhotos);
    if (!engineMode && !userDesignMode && !getSelectedBackgroundMode()) {
      ok = false;
      showError(null, errBackground, 'Vyber úpravu pozadia.');
    } else clearError(null, errBackground);
    if (!ok && scrollToFirstInvalid) scrollToCustomizerStep(1);
    return ok;
  }

  function validateStep2(scrollToFirstInvalid) {
    const ok = Boolean(getSelectedDesign());
    if (!ok) showError(null, errDesign, 'Vyber si dizajn obrazu.'); else clearError(null, errDesign);
    if (!ok && scrollToFirstInvalid) scrollToCustomizerStep(2);
    return ok;
  }

  function validateStep3(scrollToFirstInvalid) {
    let ok = true;
    if (!currentFrameValue()) { ok = false; showError(null, errFrame, 'Vyber rám.'); } else clearError(null, errFrame);
    if (!currentPickedValue()) { ok = false; showError(null, errSize, 'Vyber veľkosť.'); } else clearError(null, errSize);
    const selectedVariant = getSelectedVariant();
    if (currentFrameValue() && currentPickedValue() && (!selectedVariant || selectedVariant.available === false)) {
      ok = false; showError(null, errSize, 'Táto kombinácia je momentálne vypredaná. Vyber inú veľkosť alebo rám.');
    }
    if (!ok && scrollToFirstInvalid) scrollToCustomizerStep(3);
    return ok;
  }

  function validateStep4(scrollToFirstInvalid) {
    let ok = true;
    const designMode = getDesignMode();
    const know = isKnowMode();

    [errSubject, errYear, errEngine, errKw, errEngineCode, errSpz].forEach(function (err) {
      if (err) { err.textContent = ''; err.style.display = 'none'; }
    });
    [subjectEl, yearEl, engineEl, kwEl, engineCodeEl, spzEl].forEach(function (input) {
      if (input) input.classList.remove('input-invalid');
    });

    if (designMode === 'user_design') return true;

    if (designMode === 'title_only') {
      if (!nonEmpty(subjectEl ? subjectEl.value : '')) {
        ok = false;
        showError(subjectEl, errSubject, 'Napíš názov auta, napr. Škoda Octavia.');
      }
    } else if (designMode === 'engine') {
      if (!nonEmpty(engineEl ? engineEl.value : '')) {
        ok = false;
        showError(engineEl, errEngine, 'Doplň typ motora.');
      }
    } else {
      /* V298: povinná je len ŠPZ. Rok kontrolujeme iba vtedy, keď ho
         zákazník vyplnil, aby sa do objednávky nedostal nezmysel. */
      const yearValue = (yearEl ? yearEl.value : '').trim();
      if (know && yearValue && !isValidYear(yearValue)) { ok = false; showError(yearEl, errYear, 'Rok výroby napíš ako 4 číslice, alebo ho nechaj prázdny.'); }
      const rawSpz = (spzEl && spzEl.value || '').trim();
      const country = spzCountryEl ? spzCountryEl.value : 'SK';
      if (!isValidSpz(rawSpz, country)) {
        ok = false;
        showError(spzEl, errSpz, 'Zadaj SPZ / EČV.');
      }
    }

    updateVehicleRequirementLabels();
    if (!ok && scrollToFirstInvalid) scrollToCustomizerStep(4);
    return ok;
  }

  function validateBeforeAdd(scrollToFirstInvalid) {
    const ok1 = validateStep1(scrollToFirstInvalid);
    const ok2 = validateStep2(scrollToFirstInvalid && ok1);
    const ok3 = validateStep3(scrollToFirstInvalid && ok1 && ok2);
    const ok4 = validateStep4(scrollToFirstInvalid && ok1 && ok2 && ok3);
    const okRights = !rightsConfirm || rightsConfirm.checked;
    if (!okRights) showCartError('Pred objednaním potvrď, že máš právo použiť nahrané fotografie, texty alebo grafiku.');
    return ok1 && ok2 && ok3 && ok4 && okRights;
  }

  function goToStep(stepNumber) {
    currentStep = stepNumber;
    const successMode = stepNumber === 5;
    if (purchaseBar) purchaseBar.hidden = successMode;
    document.documentElement.classList.toggle('ao-has-purchase-bar', !!purchaseBar && !successMode);

    Object.keys(stepEls).forEach(function (key) {
      const el = stepEls[key];
      if (!el) return;
      const number = Number(key);
      const shouldShow = successMode ? number === 5 : number >= 1 && number <= 4;
      el.classList.toggle('vehicle-step--hidden', !shouldShow);
      el.classList.toggle('vehicle-step--active', shouldShow && number === stepNumber);
    });

    if (!successMode) {
      moveRealUploaderIntoBox();
      bindUploadInputEvents();
      startUploadPolling();
      syncFilesStateFromUploadInput();
    } else {
      stopUploadPolling();
      setPreviewLoading(false);
    }

    updateSummary(false);
    updateStepState();
    updateStickyTopOffset();
    updateStickyProgressVisibility();

    requestAnimationFrame(function () {
      if (successMode) {
        scrollToCustomizerStep(5);
      } else if (stepNumber >= 1 && stepNumber <= 4) {
        scrollToCustomizerStep(stepNumber);
      }
    });
  }

  function getPropertiesPayload() {
    const designMode = getDesignMode();
    const know = isKnowMode();
    return Object.assign({}, {
      '_Typ doručenia': 'custom_art',
      'Rám': frameLabelFromValue(currentFrameValue()) || '',
      'Veľkosť': baseSizeFromValue(currentPickedValue()) || '',
      'Dizajn': getSelectedDesign(),
      '_Údaje o vozidle': getStep2ModeLabel(),
      'Typ / model auta': (subjectEl.value || '').trim(),
      'Rok výroby': designMode === 'car' && know ? (yearEl.value || '').trim() : '',
      'Motor': (designMode === 'car' && know) || designMode === 'engine' ? (engineEl.value || '').trim() : '',
      '_Typ motora': designMode === 'engine' ? (engineEl.value || '').trim() : '',
      'Výkon': (designMode === 'car' && know) || designMode === 'engine' ? (kwEl.value || '').trim() : '',
      'Kód motora': designMode === 'engine' ? (engineCodeEl.value || '').trim() : '',
      'Krajina SPZ': designMode === 'car' && spzCountryEl ? spzCountryEl.value : '',
      'SPZ': designMode === 'car' ? (spzEl.value || '').trim().toUpperCase() : '',
      'Poznámka': (noteEl.value || '').trim(),
      'Úprava pozadia': getEffectiveBackgroundMode(),
      'Počet fotiek': String(filesState.length),
      '_Fotky - názvy súborov': filesState.length ? filesState.map(function (f) { return f.name; }).join(', ') : '',
      '_Fotky - URL': filesState.length ? filesState.filter(function (f) { return f.source !== 'native' && f.url; }).map(function (f) { return f.url; }).join(', ') : '',
      '_Fotky - JSON': filesState.length ? JSON.stringify(serializableFilesState()) : '',
      '_Spôsob nahratia': filesState.some(function (f) { return f.source === 'native'; }) ? 'Shopify fallback upload' : 'Upload-Lift',
      'Práva k nahraným podkladom': rightsConfirm && rightsConfirm.checked ? 'Potvrdené' : '',
      'Súhlas so zverejnením': publishAll && publishAll.checked ? 'Web, sociálne siete a reklamy' : 'Nie',
      'Návrh e-mailom do 48 hodín': 'Áno'
    });
  }

  function newSubmissionId() {
    return window.crypto?.randomUUID?.() || `ao-vehicle-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }

  function updateCartBadges(count) {
    const countSelectors = [
      '[data-cart-count]',
      '.cart-count-bubble span',
      '.cart-count',
      '.header__icon .count',
      '.site-header__cart-count',
      '.cart-link__bubble-num',
      '.header__badge',
      '.header__cart-count',
      '.header__icon-cart .count-bubble',
      '.header__icon-cart .bubble',
      '.count-bubble',
      '.cart-bubble__text-count'
    ];

    countSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = count;
        el.classList.remove('hidden');
        el.classList.remove('is-hidden');
      });
    });

    document.querySelectorAll('.cart-bubble').forEach(function (el) {
      if (count > 0) {
        el.classList.remove('visually-hidden');
        el.classList.remove('hidden');
        el.classList.remove('is-hidden');
      } else {
        el.classList.add('visually-hidden');
      }
    });
  }

  function dispatchCartEvents(cart, sections) {
    const productTitle = String(root.dataset.productTitle || document.querySelector('.vehicle-customizer-shell h1')?.textContent || '').trim();

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        productTitle: productTitle,
        data: {
          source: 'vehicle-customizer',
          itemCount: Number(cart && cart.item_count) || 0,
          sections: sections || undefined
        }
      }
    }));

    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, data: { source: 'vehicle-customizer' } } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart, data: { source: 'vehicle-customizer' } } }));
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { cart: cart } }));
    window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, data: { source: 'vehicle-customizer' } } }));
  }

  /**
   * Shopify's AJAX Cart API (/cart/add.js) does NOT persist uploaded files as
   * line item properties. When the customer's photos live in the browser
   * (native fallback), the order must be submitted through a real multipart
   * form POST to /cart/add. V148 submits that multipart form into a hidden
   * iframe, so the upload still reaches Shopify without navigating away.
   */
  function showCartError(message) {
    if (errCart) {
      errCart.textContent = message;
      errCart.style.display = 'block';
      try {
        errCart.scrollIntoView({ behavior: 'smooth', block: 'center' });
        errCart.focus({ preventScroll: true });
      } catch (error) {}
      return;
    }
    // Last resort only when the markup is missing.
    window.console && console.error('AO cart error:', message);
  }

  function clearCartError() {
    if (!errCart) return;
    errCart.textContent = '';
    errCart.style.display = 'none';
  }

  const NATIVE_CART_TARGET = 'ao-native-cart-upload-target';

  function ensureNativeCartTarget() {
    let frame = document.querySelector('iframe[data-ao-native-cart-target]');
    if (frame) return frame;
    frame = document.createElement('iframe');
    frame.name = NATIVE_CART_TARGET;
    frame.title = 'Nahrávanie produktu do košíka';
    frame.setAttribute('aria-hidden', 'true');
    frame.setAttribute('tabindex', '-1');
    frame.dataset.aoNativeCartTarget = 'true';
    frame.style.cssText = 'position:fixed;width:1px;height:1px;opacity:0;pointer-events:none;left:-9999px;bottom:0;border:0';
    document.body.appendChild(frame);
    return frame;
  }

  async function getCartSnapshot() {
    const response = await fetch(shopifyRoot + 'cart.js', {
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('cart snapshot failed');
    return response.json();
  }

  function variantQuantity(cart, variantId) {
    return (cart && Array.isArray(cart.items) ? cart.items : []).reduce(function (total, item) {
      return total + (Number(item.variant_id) === Number(variantId) ? Number(item.quantity || 0) : 0);
    }, 0);
  }

  function cartHasSubmissionId(cart, submissionId) {
    if (!submissionId || !cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(function (item) {
      return String(item.properties?.['_AO klientské ID'] || '') === String(submissionId);
    });
  }

  async function submitNativeCartInPlace(nativeForm, variantId, submissionId) {
    let before = null;
    try { before = await getCartSnapshot(); } catch (error) {}
    const beforeQty = variantQuantity(before, variantId);

    ensureNativeCartTarget();
    nativeForm.target = NATIVE_CART_TARGET;
    HTMLFormElement.prototype.submit.call(nativeForm);

    const started = Date.now();
    while (Date.now() - started < 30000) {
      await new Promise(function (resolve) { window.setTimeout(resolve, 650); });
      try {
        const current = await getCartSnapshot();
        if (cartHasSubmissionId(current, submissionId) || variantQuantity(current, variantId) > beforeQty) {
          nativeForm.remove();
          return current;
        }
      } catch (error) {}
    }

    nativeForm.remove();
    throw new Error('native-cart-upload-timeout');
  }

  function buildNativeCartForm(variantId, quantity, properties, files) {
    const form = document.createElement('form');
    form.method = 'post';
    form.action = shopifyRoot + 'cart/add';
    form.enctype = 'multipart/form-data';
    form.acceptCharset = 'UTF-8';
    form.setAttribute('hidden', 'hidden');
    form.style.display = 'none';

    const addHidden = function (name, value) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value == null ? '' : String(value);
      form.appendChild(input);
    };

    addHidden('form_type', 'product');
    addHidden('utf8', '✓');
    addHidden('id', variantId);
    addHidden('quantity', quantity);
    /* Fotografie sa musia odoslať natívne (cez AJAX by Shopify uložil iba
       názov súboru). Odpoveď smeruje do skrytého iframe na cart.js, takže
       hlavná stránka zostane bez reloadu. */
    addHidden('return_to', shopifyRoot + 'cart.js');

    Object.keys(properties || {}).forEach(function (key) {
      addHidden('properties[' + key + ']', properties[key]);
    });

    let attached = 0;
    files.forEach(function (entry, index) {
      if (!entry || !entry.file) return;
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.name = 'properties[Fotografia ' + (index + 1) + ']';
      try {
        const transfer = new DataTransfer();
        transfer.items.add(entry.file);
        fileInput.files = transfer.files;
      } catch (error) {
        return;
      }
      form.appendChild(fileInput);
      attached += 1;
    });

    if (!attached) return null;

    /* V147: `return_to` sa pridávalo DVAKRÁT s odlišnou hodnotou (najprv
       späť na konfigurátor, potom na košík). Výsledok závisel od toho, ktoré
       pole server prečítal ako posledné. Necháme jediný zámer — zákazník sa
       vráti na konfigurátor, kde mu ukážeme potvrdenie. */
    document.body.appendChild(form);
    return form;
  }

  /*
   * V254 — PRVÝ POKUS V IN-APP PREHLIADAČI.
   * Hlásené z Instagramu: prvé pridanie do košíka spadlo na „skontroluj
   * pripojenie", druhé prešlo. In-app prehliadač Instagramu a Facebooku
   * štartuje sieť aj cookies s oneskorením, takže úplne prvá požiadavka
   * sa občas stratí. Jeden tichý pokus navyše to vyrieši bez toho, aby
   * zákazník čokoľvek riešil — a nevyrobí duplicitu, lebo pred ním beží
   * kontrola, či sa položka do košíka nakoniec nedostala.
   */
  async function addToCartAjax(attempt) {
    const variant = getSelectedVariant();

    if (!variant) {
      showCartError('Nepodarilo sa nájsť zvolenú kombináciu produktu. Vyber prosím inú veľkosť alebo rám.');
      console.error('Variant not found');
      return false;
    }
    if (variant.available === false) {
      showCartError('Táto kombinácia je momentálne vypredaná. Vyber prosím inú veľkosť alebo rám.');
      return false;
    }

    clearCartError();

    const originalText = btnAddToCart.textContent;
    const originalPurchaseText = purchaseAdd ? purchaseAdd.textContent : '';
    /* V245: v lepiacom pruhu je na text miesto pre tri slová. Dlhá veta ho
       rozhodila a prekryla cenu — do pruhu ide skratka, celé znenie ostáva
       na veľkom tlačidle v zhrnutí. */
    const busyText = filesState.length ? 'Nahrávam fotky…' : 'Pridávam…';
    const busyTextLong = filesState.length ? 'Pridávam fotky, môže to trvať 10 sekúnd…' : 'Pridávam do košíka…';
    btnAddToCart.disabled = true;
    btnAddToCart.textContent = busyText;
    btnAddToCart.setAttribute('aria-busy', 'true');
    if (purchaseAdd) {
      purchaseAdd.disabled = true;
      purchaseAdd.textContent = busyText;
      purchaseAdd.setAttribute('aria-busy', 'true');
    }
    const submissionId = newSubmissionId();

    try {
      const formData = new FormData();
      formData.set('id', String(cartVariantId(variant)));
      formData.set('quantity', '1');

      const properties = getPropertiesPayload();
      properties['_AO klientské ID'] = submissionId;
      Object.keys(properties).forEach(function (key) {
        formData.append('properties[' + key + ']', String(properties[key] == null ? '' : properties[key]));
      });

      // Photos held in the browser must go through a native multipart POST,
      // otherwise Shopify stores only the file name and the artwork is lost.
      const nativeFiles = filesState.filter(function (file) { return file.source === 'native' && file.file; });
      if (nativeFiles.length) {
        const nativeForm = buildNativeCartForm(cartVariantId(variant), 1, properties, nativeFiles);
        if (nativeForm) {
          track('vehicle_add_to_cart_attempt', {
            variant_id: variant.id,
            design: getSelectedDesign(),
            photos: nativeFiles.length,
            upload_mode: 'native_form'
          });
          /* V246: dlhá veta patrí veľkému tlačidlu v stránke. V lepiacej lište
             dole rozhodí layout — prekryje cenu aj stav. Tam ostáva krátky text. */
          btnAddToCart.textContent = busyTextLong;
          if (purchaseAdd) purchaseAdd.textContent = busyText;
          document.dispatchEvent(new CustomEvent('ao:native-cart-submit', {
            bubbles: true,
            detail: { form: nativeForm, variantId: variant.id, photos: nativeFiles.length, inPlace: true }
          }));

          /* Multipart upload ide do skrytého iframe. Shopify tak stále dostane
             reálne File objekty, ale hlavná stránka sa vôbec neopustí. */
          const cart = await submitNativeCartInPlace(nativeForm, variant.id, submissionId);
          updateCartBadges(cart.item_count || 0);
          dispatchCartEvents(cart);
          track('vehicle_add_to_cart_success', {
            variant_id: variant.id,
            item_count: cart.item_count || 0,
            upload_mode: 'native_iframe'
          });
          return true;
        }
        showError(null, errPhotos, 'Fotografie sa nepodarilo pripraviť na odoslanie. Skús ich prosím nahrať znova.');
        track('vehicle_add_to_cart_failed', { message: 'native_form_build_failed' });
        return false;
      }

      track('vehicle_add_to_cart_attempt', {
        variant_id: variant.id,
        design: getSelectedDesign(),
        photos: filesState.length,
        upload_mode: filesState.some(function (file) { return file.source === 'native'; }) ? 'native' : 'upload_lift'
      });

      const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map(function (el) { return el.dataset.sectionId; })
        .filter(Boolean);
      const uniqueSectionIds = Array.from(new Set(sectionIds));
      if (uniqueSectionIds.length) {
        formData.set('sections', uniqueSectionIds.join(','));
        formData.set('sections_url', window.location.pathname);
      }

      const response = await fetch(shopifyRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });

      if (!response.ok) {
        throw new Error('Cart add failed');
      }
      let data = {};
      try { data = await response.json(); } catch (error) { /* POST bol prijatý. */ }

      /* Refresh odznaku je sekundárny krok. Jeho zlyhanie nesmie zmeniť
         úspešné pridanie na hlášku „produkt sa nepodarilo pridať“. */
      let cart = { item_count: Math.max(1, Number(window.AOPageContext?.cartCount || 0) + 1) };
      try {
        const cartRes = await fetch(shopifyRoot + 'cart.js', {
          method: 'GET',
          headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' },
          cache: 'no-store'
        });
        if (cartRes.ok) cart = await cartRes.json();
      } catch (error) { /* Odznak sa zosúladí pri ďalšom cart evente. */ }

      updateCartBadges(cart.item_count || 0);

      document.querySelectorAll('.header-actions__cart-icon').forEach(function (el) {
        if ((cart.item_count || 0) > 0) {
          el.classList.add('header-actions__cart-icon--has-cart');
        } else {
          el.classList.remove('header-actions__cart-icon--has-cart');
        }
      });

      dispatchCartEvents(cart, data && data.sections ? data.sections : null);
      track('vehicle_add_to_cart_success', { variant_id: variant.id, item_count: cart.item_count || 0 });

      return true;
    } catch (e) {
      /* Pri stratenej odpovedi over presné ID konfigurácie skôr, než
         zákazníka vyzveme na ďalší klik a vytvoríme duplicitu. */
      try {
        const recovered = await getCartSnapshot();
        if (cartHasSubmissionId(recovered, submissionId)) {
          updateCartBadges(recovered.item_count || 0);
          dispatchCartEvents(recovered);
          track('vehicle_add_to_cart_success', { variant_id: variant.id, item_count: recovered.item_count || 0, mode: 'recovered' });
          return true;
        }
      } catch (recoveryError) {}
      const tries = Number(attempt) || 1;
      if (tries < 2) {
        track('vehicle_add_to_cart_retry', { message: e && e.message ? e.message : 'unknown' });
        await new Promise(function (resolve) { window.setTimeout(resolve, 700); });
        return addToCartAjax(tries + 1);
      }
      track('vehicle_add_to_cart_failed', { message: e && e.message ? e.message : 'unknown' });
      showCartError('Produkt sa nepodarilo pridať do košíka. Skontroluj pripojenie a skús to prosím znova.');
      return false;
    } finally {
      btnAddToCart.disabled = false;
      btnAddToCart.textContent = originalText;
      btnAddToCart.removeAttribute('aria-busy');
      if (purchaseAdd) {
        purchaseAdd.disabled = false;
        purchaseAdd.textContent = originalPurchaseText;
        purchaseAdd.removeAttribute('aria-busy');
      }
    }
  }

  function resetWizard() {
    clearVehicleDraft();
    clearNativeFiles();
    setNativeFallbackActive(false);
    attempted = false;
    suppressUploadedFiles = true;
    filesState = [];
    summaryThumbHtml = '';
    lastCompleteState = false;
    clearCelebrationClasses();
    stopUploadPolling();
    setPreviewLoading(false);

    root.querySelectorAll('input[name="custom_frame"]').forEach(function (el) {
      el.checked = el.value === 'S rámom';
    });

    root.querySelectorAll('input[name="custom_size"]').forEach(function (el) {
      el.checked = el.value === 'A3';
    });
    updateSizeCardPrices();

    root.querySelectorAll('input[name="properties[Dizajn]"]').forEach(function (el) {
      el.checked = false;
    });

    root.querySelectorAll('input[name="properties[Údaje o vozidle]"]').forEach(function (el) {
      el.checked = el.value === 'Viem údaje';
    });

    root.querySelectorAll('input[name="properties[Úprava pozadia]"]').forEach(function (el) {
      el.checked = el.value === 'Použiť pozadie z fotky';
    });

    if (subjectEl) subjectEl.value = '';
    yearEl.value = '';
    engineEl.value = '';
    kwEl.value = '';
    if (engineCodeEl) engineCodeEl.value = '';
    spzEl.value = '';
    if (spzCountryEl) spzCountryEl.value = 'SK';
    noteEl.value = '';
    if (publishAll) publishAll.checked = true;
    /* V230: prepínač platby sa po pridaní do košíka neresetuje —
       nič sa tu neprepína. */

    if (frameProperty) frameProperty.value = '';
    if (sizeProperty) sizeProperty.value = '';

    removeRealUploadFromApp().catch(function () {});

    const uploadValueInput = getUploadValueInput();
    if (uploadValueInput) uploadValueInput.value = '';

    syncUploadHiddenFields();

    clearError(null, errFrame);
    clearError(null, errSize);
    clearError(null, errDesign);
    clearError(subjectEl, errSubject);
    clearError(yearEl, errYear);
    clearError(engineEl, errEngine);
    clearError(kwEl, errKw);
    clearError(engineCodeEl, errEngineCode);
    clearError(spzEl, errSpz);
    clearError(null, errPhotos);
    clearError(null, errBackground);

    renderPreviews();
    updateStatus();
    setModeUI();

    updateSummary(false);
    updateStepState();
    goToStep(1);
  }

  // V63 uses the native browser picker only. External upload-app events are intentionally ignored.

  /* Výber krajiny SPZ. Registrácia bola omylom vnútri resetWizard(), takže
     pri prvom načítaní stránky nemal handler vôbec a každé „Vytvoriť ďalší
     obraz“ pridalo ďalší duplicitný listener. */
  if (spzCountryEl) {
    spzCountryEl.addEventListener('change', function () {
      updateSpzCountryUI();
      updateSummary(true);
      updateStepState();
      scheduleVehicleDraftSave();
      if (attempted && currentStep >= 4) validateStep4(false);
    });
  }

  knowRadios.forEach(function (r) {
    r.addEventListener('change', setModeUI);
  });

  [subjectEl, yearEl, engineEl, kwEl, engineCodeEl, spzEl, noteEl].forEach(function (el) {
    if (!el) return;
    el.addEventListener('input', function () {
      if (el === spzEl) el.value = (el.value || '').toUpperCase();
      updateVehicleRequirementLabels();
      updateSummary(true);
      updateStepState();
      updateLiveMockup();
      scheduleVehicleDraftSave();
      if (attempted && currentStep >= 4) validateStep4(false);
    });

    el.addEventListener('blur', function () {
      updateVehicleRequirementLabels();
      updateSummary(true);
      updateStepState();
      updateLiveMockup();
      scheduleVehicleDraftSave();
      if (attempted && currentStep >= 4) validateStep4(false);
    });
  });

  root.querySelectorAll('input[name="properties[Úprava pozadia]"]').forEach(function (el) {
    el.addEventListener('change', function () {
      clearError(null, errBackground);
      updateSummary(true);
      updateStepState();
      updateLiveMockup();
      scheduleVehicleDraftSave();
    });
  });

  root.addEventListener('change', function (e) {
    if (e.target && e.target.matches('input[type="radio"][name="custom_size"]')) {
      applySelection();
      if (attempted) validateStep3(false);
    } else if (e.target && e.target.matches('input[type="radio"][name="custom_frame"]')) {
      applySelection();
      if (attempted) validateStep3(false);
    } else if (e.target && e.target.matches('input[name="properties[Dizajn]"]')) {
      clearError(null, errDesign);
      setModeUI();
      updateSummary(true);
      updateStepState();
      updateLiveMockup();
      scheduleVehicleDraftSave();
      if (attempted) validateStep2(false);
    } else if (e.target && e.target.matches('.option-card input[type="radio"]')) {
      updateSummary(true);
      updateStepState();
    }
  });

  root.addEventListener('click', function (e) {
    const sizeCard = e.target.closest && e.target.closest('.size-card');
    if (sizeCard) {
      const input = sizeCard.querySelector('input[type="radio"]');
      if (!input) return;
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    const optionCard = e.target.closest && e.target.closest('.option-card');
    if (optionCard) {
      const input = optionCard.querySelector('input[type="radio"]');
      if (!input) return;
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  root.querySelectorAll('[data-v52-scroll]').forEach(function (button) {
    button.addEventListener('click', function () {
      const target = Number(button.dataset.v52Scroll || 1);
      // Mäkký wizard: medzi krokmi zákazníka neblokujeme. Chýbajúce údaje
      // priebežne ukazuje progress + pevná nákupná lišta; tvrdá kontrola je až
      // pri reálnom pridaní do košíka, kde zvýrazníme konkrétne pole.
      currentStep = target;
      scrollToCustomizerStep(target);
    });
  });

  technicalDetails?.addEventListener('toggle', function () { scheduleVehicleDraftSave(); });

  purchaseAdd?.addEventListener('click', function () {
    attempted = true;
    syncFilesStateFromUploadInput();
    if (!validateBeforeAdd(true)) return;
    btnAddToCart.click();
  });

  btnToStep2?.addEventListener('click', function () {
    attempted = true;
    if (!validateStep1(true)) return;
    goToStep(2);
  });

  btnToStep3?.addEventListener('click', function () {
    attempted = true;
    if (!validateStep2(true)) return;
    goToStep(3);
  });

  btnToStep4?.addEventListener('click', function () {
    attempted = true;
    syncFilesStateFromUploadInput();
    if (!validateStep3(true)) return;
    updateSummary(false);
    goToStep(4);
  });

  btnBack1?.addEventListener('click', function () {
    goToStep(1);
  });

  btnBack2?.addEventListener('click', function () {
    goToStep(2);
  });

  btnBack3?.addEventListener('click', function () {
    goToStep(3);
  });

  if (stickyBackButton) {
    stickyBackButton.addEventListener('click', function () {
      if (currentStep >= 2 && currentStep <= 4) goToStep(currentStep - 1);
    });
  }

  if (openSpecialDesignModalButton) {
    openSpecialDesignModalButton.addEventListener('click', openSpecialDesignModal);
  }

  if (specialDesignModal) {
    specialDesignModal.querySelectorAll('[data-special-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeSpecialDesignModal);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && specialDesignModal && specialDesignModal.classList.contains('is-open')) {
      closeSpecialDesignModal();
    }
  });

  btnAddToCart.addEventListener('click', async function () {
    attempted = true;
    syncFilesStateFromUploadInput();

    if (!validateBeforeAdd(true)) return;

    const ok = await addToCartAjax();
    if (!ok) return;

    clearVehicleDraft();
    if (successText) {
      successText.textContent = 'Obraz je v košíku. Návrh ti do 48 hodín pošleme na e-mail — tlačíme až po tom, čo ho schváliš.';
    }
    /* V245: krok 5 je v DOM až za informačnými panelmi, takže potvrdenie
       končilo na úplnom spodku stránky. Presunieme ho hneď za krok, v ktorom
       stojí tlačidlo „Pridať do košíka" — tam sa človek práve pozerá. */
    var successStep = document.getElementById('step_success');
    var addBtnStep = document.getElementById('add_to_cart_custom');
    addBtnStep = addBtnStep ? addBtnStep.closest('.vehicle-step') : null;
    if (successStep && addBtnStep && addBtnStep.parentNode && successStep.previousElementSibling !== addBtnStep) {
      addBtnStep.parentNode.insertBefore(successStep, addBtnStep.nextSibling);
    }

    goToStep(5);
    // V230: potvrdenie musí byť pred očami, nie na konci stránky.
    setTimeout(scrollToSuccessBox, 60);
  });

  btnCreateNew.addEventListener('click', function () {
    resetWizard();
  });

  btnCheckout.addEventListener('click', function () {
    /* Cez košík, nie priamo na /checkout. Priamy skok obchádzal
       zosúladenie darčeka a ochrany zásielky a ignoroval Shopify.routes
       (rozbil by sa na jazykovo prefixovaných URL). */
    window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root : '/') + 'cart';
  });

  const savedVehicleDraft = readVehicleDraft();
  if (savedVehicleDraft && draftResume) draftResume.hidden = false;
  draftContinue?.addEventListener('click', function () {
    restoreVehicleDraft(savedVehicleDraft);
    if (draftResume) draftResume.hidden = true;
    track('vehicle_draft_restored', {});
  });
  draftDiscard?.addEventListener('click', function () {
    clearVehicleDraft();
    track('vehicle_draft_discarded', {});
  });

  window.addEventListener('scroll', updateStickyProgressVisibility, { passive: true });
  const onVehicleViewportResize = window.AOViewport
    ? window.AOViewport.onResize
    : function (fn) { window.addEventListener('resize', fn, { passive: true }); };
  onVehicleViewportResize(function () {
    updateStickyTopOffset();
    updateStickyProgressVisibility();
    updateShippingStatusBar();
  });

  function initVehicleResultsCarousel() {
    document.querySelectorAll('[data-vehicle-results-carousel]').forEach(function (carousel) {
      if (carousel.dataset.initialized === 'true') return;
      carousel.dataset.initialized = 'true';
      const viewport = carousel.querySelector('[data-vehicle-results-viewport]');
      const pages = Array.from(carousel.querySelectorAll('[data-vehicle-results-page]'));
      const dotsWrap = carousel.querySelector('[data-vehicle-results-dots]');
      const prev = carousel.querySelector('[data-vehicle-results-prev]');
      const next = carousel.querySelector('[data-vehicle-results-next]');
      if (!viewport || !pages.length) return;

      let current = 0;
      const dots = pages.map(function (_, index) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Zobraziť realizácie ' + (index + 1));
        dot.addEventListener('click', function () { go(index); });
        if (dotsWrap) dotsWrap.appendChild(dot);
        return dot;
      });

      function paint(index) {
        current = Math.max(0, Math.min(pages.length - 1, index));
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === current); });
        if (prev) prev.disabled = current === 0;
        if (next) next.disabled = current === pages.length - 1;
      }

      function go(index) {
        const target = pages[Math.max(0, Math.min(pages.length - 1, index))];
        if (!target) return;
        viewport.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        paint(index);
      }

      prev?.addEventListener('click', function () { go(current - 1); });
      next?.addEventListener('click', function () { go(current + 1); });
      let raf = 0;
      viewport.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          const width = Math.max(1, viewport.clientWidth);
          paint(Math.round(viewport.scrollLeft / width));
        });
      }, { passive: true });
      paint(0);
    });
  }

  // Dates are server-rendered immediately and refined as soon as JS is ready.
  updateShippingStatusBar();

  const finishVehicleInitialization = function () {
    const ensureChecked = function (selector) {
      const items = [...root.querySelectorAll(selector)];
      if (!items.some(function (item) { return item.checked; }) && items[0]) items[0].checked = true;
    };
    // V54: do not silently choose the first (ŠKODA) example for the customer.
    // A design must be an explicit customer choice after the photo is uploaded.
    if (!savedVehicleDraft) {
      root.querySelectorAll('input[name="properties[Dizajn]"]').forEach(function (item) { item.checked = false; });
    }
    ensureChecked('input[name="properties[Úprava pozadia]"]');

    updateStickyTopOffset();
    updateStickyProgressVisibility();
    updateShippingStatusBar();

    if (window.location.hash === '#vehicle_customizer_top') {
      setTimeout(function () {
        scrollToPageTopSection();
      }, 300);
    }

    initVehicleResultsCarousel();

    const infoItems = document.querySelectorAll('.vehicle-info-item');
    infoItems.forEach(function (item) {
      const trigger = item.querySelector('.vehicle-info-trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');
        infoItems.forEach(function (other) { other.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    });

    Object.keys(stepEls).forEach(function (key) {
      const el = stepEls[key];
      if (!el) return;
      const number = Number(key);
      const shouldShow = number >= 1 && number <= 4;
      el.classList.toggle('vehicle-step--hidden', !shouldShow);
      el.classList.toggle('vehicle-step--active', number === 1);
    });

    if (savedVehicleDraft) restoringDraft = true;
    stopUploadPolling();
    bindNativeUpload();
    setNativeFallbackActive(true);
    updateShippingStatusBar();
    updateStatus();
    setModeUI();
    updateVehicleRequirementLabels();
    updateSummary(false);
    updateStepState();
    updateProgressBar();
    updateStickyTopOffset();
    updateStickyProgressVisibility();
    updateLiveMockup();
    updatePurchaseBar();
    if (savedVehicleDraft) restoringDraft = false;
  };

  if (document.readyState === 'complete') finishVehicleInitialization();
  else window.addEventListener('load', finishVehicleInitialization, { once: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVehicleCustomizer, { once: true });
} else {
  initVehicleCustomizer();
}
document.addEventListener('shopify:section:load', initVehicleCustomizer);
})();
